<template>
	<div>
		<!-- Main -->
		<nav id="header" class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo uk-text-small" style="padding: 0 !important; margin-right: 8px !important; font-size: 16px !important;">
					<template v-if="this.roles.is_call_center || this.roles.is_branch_office || this.roles.is_main_office">
						<router-link class="uk-icon uk-margin-medium-right" uk-icon="reply" v-bind:to="toReturnURL"></router-link>
					</template>
					<template v-if="shop != null">
						<span class="uk-margin-small-left uk-margin-small-right">{{ shop.name }}</span>
					</template>
				</span>
				<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
					<button class="uk-button uk-button-small button_normal" @click="disableAllDisplayMode">通常</button>
				</div>
				<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
					<button class="uk-button uk-button-small button_list" @click="enableAllDisplayMode">一覧</button>
				</div>
				<template v-if="this.roles.is_staff && this.roles.is_admin_staff">
					<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
						<a class="uk-button uk-button-small uk-button-default button_todo" @click="toDigitalSignage">サイネージ</a>
					</div>
				</template>
				<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
					<button class="uk-button uk-button-small uk-button-default button_todo uk-text-capitalize" @click="showTodoListDialog">ToDo</button>
				</div>
				<template v-if="this.roles.is_staff || this.roles.is_admin_staff">
					<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
						<span class="uk-icon-button" uk-icon="lock" @click="enableLockMode"></span>
					</div>
				</template>
				<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
					<span class="uk-icon-button" uk-icon="refresh" onclick="window.location.reload()"></span>
				</div>
				<template v-if="this.roles.is_staff">
					<div class="uk-navbar-item uk-margin-large-left" style="padding: 0 !important; margin-right: 8px !important;">
						<a class="uk-button uk-button-small uk-button-primary" @click="toShopAnotherSearch">他店舗状況照会</a>
					</div>
				</template>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<template v-if="this.roles.is_admin_staff || this.roles.is_call_center || this.roles.is_branch_office || this.roles.is_main_office">
					<template v-if="this.is_all_receive_notification">
						<div class="uk-navbar-item">
							<button id="change_mode_receive_notification" class="uk-button uk-button-small uk-button-primary" @click="changeModeReceiveNotification">全通知ON</button>
						</div>
					</template>
					<template v-else>
						<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
							<button id="change_mode_receive_notification" class="uk-button uk-button-small uk-button-default" @click="changeModeReceiveNotification">全通知OFF</button>
						</div>
					</template>
					<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
						<span id="change_reservation_delete_mode" class="uk-icon-button" uk-icon="trash" @click="onClickShowDeletedReservations"></span>
					</div>
					<template v-if="this.roles.is_admin_staff">
						<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
							<router-link class="uk-icon-button" uk-icon="cog" to="/shop"></router-link>
						</div>
					</template>
				</template>
				<div class="uk-navbar-item" style="padding: 0 !important; margin-right: 8px !important;">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand">
			<ul class="uk-navbar-nav">
				<div class="uk-navbar-left">
					<li class="uk-navbar-item">予約総数 {{ reservation_total }} 件</li>
					<li class="uk-navbar-item"><span class="uk-button uk-button-small uk-button-default" @click="showReservationBreakdownDialog">内訳</span></li>
					<li><span id="staff_list_add_staff" class="uk-button uk-button-small uk-button-default" @click="onClickAddStaff">スタッフ追加</span></li>
				</div>
				<div class="uk-navbar-right">
					<li class="uk-navbar-item">
						<el-date-picker id="el_datepicker" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" :value="this.params.date" placeholder="YYYY/MM/DD" @input="selectedDatePicker"></el-date-picker>
					</li>
				</div>
			</ul>
		</div>
		<!--/ Main -->
		<!-- Scheduler -->
		<div id="scroll" class="uk-overflow-hidden">
			<template v-if="is_staff_list_minimum">
				<span id="staff_list_toggle" class="uk-icon-button" uk-icon="plus" @click="onClickStaffListToggle"></span>
			</template>
			<template v-else>
				<span id="staff_list_toggle" class="uk-icon-button" uk-icon="minus" @click="onClickStaffListToggle"></span>
			</template>
			<span id="left_scroll_button" class="uk-icon-button" uk-icon="arrow-left" @click="onClickArrowLeft"></span>
			<span id="up_scroll_button" class="uk-icon-button" uk-icon="arrow-up" @click="onClickArrowUp"></span>
			<div id="scheduler">
				<div id="staff_list_wrapper">
					<div id="staff_list">
						<table id="staff_list_table" class="normal" cellpadding="0" cellspacing="0" border="solid 1px #DDD">
							<tbody>
							<tr id="row_reservation">
								<th>区分</th>
								<template v-for="work_schedule in work_schedules">
									<td v-bind:data-staff-id="work_schedule.staff.id" :key="work_schedule.id" @click="onClickChangeLaneType(work_schedule.id)">
										<template v-if="work_schedule.lane_type != 0 && work_schedule.lane_type != null">
											<template v-if="work_schedule.lane_type == 1">
												予約
											</template>
											<template v-if="work_schedule.lane_type == 2">
												本日の教室
											</template>
											<template v-if="work_schedule.lane_type == 3">
												次回の教室
											</template>
										</template>
									</td>
								</template>
							</tr>
							<tr id="row_name">
								<th>名前</th>
								<template v-for="work_schedule in work_schedules">
									<td v-bind:data-staff-id="work_schedule.staff.id" :key="work_schedule.id">{{ work_schedule.staff.display_name}}</td>
								</template>
							</tr>
							<template v-if="is_staff_list_minimum != true">
								<tr id="row_job_position">
									<th>役割</th>
									<template v-for="work_schedule in work_schedules">
										<td v-bind:data-staff-id="work_schedule.staff.id" :key="work_schedule.id" @click="showStaffShopDailyJobPositionDailog(work_schedule.staff.id)">
											{{ staff_today_shop_job_positions[work_schedule.staff.id] }}
											&nbsp;
										</td>
									</template>
								</tr>
								<tr id="row_skill_attribute">
									<th @click="toggleStaffSkillAttributes">スキル</th>
									<template v-for="work_schedule in work_schedules">
										<td v-bind:data-staff-id="work_schedule.staff.id" :key="work_schedule.id">
											<template v-if="is_display_staff_skill_attributes">
												<ul class="uk-list">
													<template v-for="staff_skill_attribute in staff_skill_attributes[work_schedule.staff.id]">
														<li :key="staff_skill_attribute.id">{{ staff_skill_attribute.shop_skill_attribute.skill_attribute.name }}</li>
													</template>
												</ul>
											</template>
											<template v-else>
												&nbsp;
											</template>
										</td>
									</template>
								</tr>
								<tr id="row_todo">
									<th>ToDo</th>
									<template v-for="work_schedule in work_schedules">
										<td v-bind:data-staff-id="work_schedule.staff.id" :key="work_schedule.id" @click="staffTodoDialog(work_schedule.staff_id)">
											<template v-if="staff_todo_count[work_schedule.staff.id] != null">
												{{ staff_todo_count[work_schedule.staff.id] }}
											</template>
										</td>
									</template>
								</tr>
								<tr id="row_start">
									<th>出勤</th>
									<template v-for="work_schedule in work_schedules">
										<td v-bind:data-staff-id="work_schedule.staff.id" :key="work_schedule.id">{{ work_schedule.start | moment }}</td>
									</template>
								</tr>
								<tr id="row_end">
									<th>退勤</th>
									<template v-for="work_schedule in work_schedules">
										<td v-bind:data-staff-id="work_schedule.staff.id" :key="work_schedule.id">{{ work_schedule.end | moment }}</td>
									</template>
								</tr>
							</template>
							</tbody>
						</table>
					</div>
				</div>
				<DayPilotCalendar id="dp" :config="daypilot.config" ref="calendar"></DayPilotCalendar>
			</div>
		</div>
		<!--/ Scheduler -->

		<!-- CreateEventDialog -->
		<div id="create_event_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-margin-small-bottom uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_event_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="create_event_form">
					<div class="uk-form-horizontal">
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_date">日付 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-date-picker id="create_event_form_date" name="date" style="width:100%;" v-model="create_event_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="changeCreateTime"></el-date-picker>
									</template>
									<template v-else>
										<el-date-picker id="create_event_form_date" name="date" style="width:100%;" v-model="create_event_date_picker" format="yyyy/MM/dd" :type="date" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="changeCreateTime"></el-date-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.date != undefined">
										<template v-for="(error,index) in this.createFormState.errors.date">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="create_event_form_plan_start_time">開始時間 (必須)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="create_event_form_plan_start_time" style="width:100%;" v-model="create_reservation_dialog_start_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="create_event_form_plan_start_time" style="width:100%;" v-model="create_reservation_dialog_start_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.plan_start_time != undefined">
									<template v-for="(error,index) in this.createFormState.errors.plan_start_time">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_event_form_plan_end_time">終了時間 (必須)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="create_event_form_plan_end_time" style="width:100%;" v-model="create_reservation_dialog_end_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="create_event_form_plan_end_time" style="width:100%;" v-model="create_reservation_dialog_end_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.plan_end_time != undefined">
									<template v-for="(error,index) in this.createFormState.errors.plan_end_time">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_response_staff">担当者 (必須)</label>
								<div class="uk-form-controls">
									<select id="create_event_form_response_staff" class="uk-select" name="response_staff">
										<template v-for="work_schedule in work_schedules">
											<option :key="work_schedule.id" :value="work_schedule.staff.id" @change="enableNeedConfirmAlert">{{ work_schedule.staff.name}}</option>
										</template>
									</select>
									<template v-if="typeof this.createFormState.errors.response_staff_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.response_staff_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_response_staff">対応者</label>
								<div class="uk-form-controls">
									<select id="create_event_form_sub_response_staff" class="uk-select" name="sub_response_staff" @change="enableNeedConfirmAlert">
										<option value="null">選択無し</option>
										<template v-for="work_schedule in work_schedules">
											<option :key="work_schedule.id" :value="work_schedule.staff.id">{{ work_schedule.staff.name}}</option>
										</template>
									</select>
									<div class="uk-margin-small-top" style="font-size: 12px;">
										<p>※レーン運用時の対応者は選択してください。</p>
										<p>※スタッフシフトで運用している店舗は選択不要です。</p>
									</div>
									<template v-if="typeof this.createFormState.errors.sub_response_staff_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.sub_response_staff_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_shop_job_type">業務名 (必須)</label>
								<div class="uk-form-controls">
									<select id="create_event_form_shop_job_type" class="uk-select" name="shop_job_type" @change="enableNeedConfirmAlert">
										<template v-for="shop_job_type in shop_job_types">
											<option :key="shop_job_type.id" :value="shop_job_type.id">{{ shop_job_type.display_name}}</option>
										</template>
									</select>
									<template v-if="typeof this.createFormState.errors.shop_job_type_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.shop_job_type_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_reservation_number">受付番号</label>
								<div class="uk-form-controls">
									<input class="uk-input" id="create_event_form_reservation_number" name="reservation_number" type="text" placeholder="受付番号を入力してください" maxlength="4" @change="zenkakuToHankaku" v-on:change="enableNeedConfirmAlert">
									<template v-if="typeof this.createFormState.errors.reservation_number != undefined">
										<template v-for="(error,index) in this.createFormState.errors.reservation_number">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_client_name">お客様名 (カタカナ苗字)</label>
								<div class="uk-form-controls">
									<input class="uk-input" id="create_event_form_client_name" name="client_name" type="text" placeholder="お客様名を入力してください" required maxlength="20" @change="enableNeedConfirmAlert">
									<template v-if="typeof this.createFormState.errors.client_name != undefined">
										<template v-for="(error,index) in this.createFormState.errors.client_name">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_is_corporation">法人</label>
								<div class="uk-form-controls">
									<input class="uk-checkbox" id="create_event_form_is_corporation" name="is_corporation" type="checkbox" @change="enableNeedConfirmAlert">
									<template v-if="typeof this.createFormState.errors.is_corporation != undefined">
										<template v-for="(error,index) in this.createFormState.errors.is_corporation">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_memo">メモ<br><span style="color: red">個人情報入力禁止</span></label>
								<div class="uk-form-controls">
									<textarea class="uk-textarea" id="create_event_form_memo" name="memo" type="text" placeholder="メモを入力してください" maxlength="1000" @change="enableNeedConfirmAlert" style="height: 150px;"></textarea>
									<template v-if="typeof this.createFormState.errors.memo != undefined">
										<template v-for="(error,index) in this.createFormState.errors.memo">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="create_event_form_signage_display_text">サイネージ表示内容<br><span style="color: red">入力した内容はサイネージ画面に表示されます</span></label>
								<div class="uk-form-controls">
									<textarea class="uk-textarea" id="create_event_form_signage_display_text" name="signage_display_text" type="text" placeholder="サイネージ表示内容を入力してください" maxlength="100" style="background: #ffe4e1" @change="enableNeedConfirmAlert"></textarea>
									<template v-if="typeof this.createFormState.errors.signage_display_tex != undefined">
										<template v-for="(error,index) in this.createFormState.errors.signage_display_tex">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary uk-margin-top" type="button" @click="saveCreateEventForm">保存</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ CreateEventDialog -->

		<!-- EditEventDialog -->
		<div id="edit_event_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">編集</h2>
						<span class="uk-margin-right">最終更新者: <span id="edit_event_dialog_last_update_name"></span></span>
						<span>更新時間: <span id="edit_event_dialog_last_update_time"></span></span>
					</div>
					<div class="uk-align-right" style="position:absolute;top:10px;right:10px;">
						<span class="uk-icon-button uk-margin-small-right" uk-icon="lock" @click="enableLockMode"></span>
						<span id="edit_event_dialog_delete_button" class="uk-icon-button uk-margin-small-right" uk-icon="trash" @click="deleteEventButton"></span>
						<button id="edit_event_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_event_form">
					<div class="uk-form-horizontal">
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_date">日付 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-date-picker id="edit_event_form_date" name="date" v-model="edit_event_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="changeEditTime"></el-date-picker>
									</template>
									<template v-else>
										<el-date-picker id="edit_event_form_date" name="date" v-model="edit_event_date_picker" format="yyyy/MM/dd" :type="date" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="changeEditTime"></el-date-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.date != undefined">
										<template v-for="(error,index) in this.createFormState.errors.date">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="edit_event_form_plan_start_time">開始時間 (必須)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="edit_event_form_plan_start_time" v-model="edit_reservation_dialog_start_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="edit_event_form_plan_start_time" v-model="edit_reservation_dialog_start_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.plan_start_time != undefined">
									<template v-for="(error,index) in this.createFormState.errors.plan_start_time">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-clearfix">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_plan_end_time">終了時間 (必須)</label>
								<div class="uk-form-controls">
									<template v-if="isMobile()">
										<el-time-picker id="edit_event_form_plan_end_time" v-model="edit_reservation_dialog_end_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
									</template>
									<template v-else>
										<el-time-picker id="edit_event_form_plan_end_time" v-model="edit_reservation_dialog_end_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
									</template>
									<template v-if="typeof this.createFormState.errors.plan_end_time != undefined">
										<template v-for="(error,index) in this.createFormState.errors.plan_end_time">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_response_staff">担当者 (必須)</label>
								<div class="uk-form-controls">
									<select id="edit_event_form_response_staff" class="uk-select" name="response_staff" v-model="work_staff_select" @change="enableNeedConfirmAlert">
										<!-- <template v-for="work_schedule in work_schedules">
											<option :key="work_schedule.id" :value="work_schedule.staff.id">{{ work_schedule.staff.name}}</option>
										</template> -->
										<template v-for="work_staff in work_staffs">
											<option :key="work_staff.id" :value="work_staff.id">{{ work_staff.name}}</option>
										</template>
									</select>
									<template v-if="typeof this.createFormState.errors.response_staff_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.response_staff_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_response_staff">対応者</label>
								<div class="uk-form-controls">
									<select id="edit_event_form_sub_response_staff" class="uk-select" name="sub_response_staff" v-model="work_sub_staff_select" @change="enableNeedConfirmAlert">
										<option value="null">選択無し</option>
										<!-- <template v-for="work_schedule in work_schedules">
											<option :key="work_schedule.id" :value="work_schedule.staff.id">{{ work_schedule.staff.name}}</option>
										</template> -->
										<template v-for="work_sub_staff in work_sub_staffs">
											<option :key="work_sub_staff.id" :value="work_sub_staff.id">{{ work_sub_staff.name}}</option>
										</template>
									</select>
									<div class="uk-margin-small-top" style="font-size: 12px;">
										<p>※レーン運用時の対応者は選択してください。</p>
										<p>※スタッフシフトで運用している店舗は選択不要です。</p>
									</div>
									<template v-if="typeof this.createFormState.errors.sub_response_staff_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.sub_response_staff_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_shop_job_type">業務名 (必須)</label>
								<div class="uk-form-controls">
									<select id="edit_event_form_shop_job_type" class="uk-select" name="shop_job_type" @change="enableNeedConfirmAlert">
										<template v-for="shop_job_type in shop_job_types">
											<option :key="shop_job_type.id" :value="shop_job_type.id">{{ shop_job_type.display_name}}</option>
										</template>
									</select>
									<template v-if="typeof this.createFormState.errors.shop_job_type_id != undefined">
										<template v-for="(error,index) in this.createFormState.errors.shop_job_type_id">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_reservation_number">受付番号</label>
								<div class="uk-form-controls">
									<input class="uk-input" id="edit_event_form_reservation_number" name="reservation_number" type="text" placeholder="受付番号を入力してください" maxlength="4" @change="zenkakuToHankaku" v-on:change="enableNeedConfirmAlert">
									<template v-if="typeof this.createFormState.errors.reservation_number != undefined">
										<template v-for="(error,index) in this.createFormState.errors.reservation_number">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_client_name">お客様名 (カタカナ苗字)</label>
								<div class="uk-form-controls">
									<input class="uk-input" id="edit_event_form_client_name" name="client_name" type="text" placeholder="お客様名を入力してください" required maxlength="20" @change="enableNeedConfirmAlert">
									<template v-if="typeof this.createFormState.errors.client_name != undefined">
										<template v-for="(error,index) in this.createFormState.errors.client_name">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_is_corporation">法人</label>
								<div class="uk-form-controls">
									<input class="uk-checkbox" id="edit_event_form_is_corporation" name="is_corporation" type="checkbox" @change="enableNeedConfirmAlert">
									<template v-if="typeof this.createFormState.errors.is_corporation != undefined">
										<template v-for="(error,index) in this.createFormState.errors.is_corporation">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_memo">メモ<br><span style="color: red">個人情報入力禁止</span></label>
								<div class="uk-form-controls">
									<textarea class="uk-textarea" id="edit_event_form_memo" name="memo" type="text" placeholder="メモを入力してください" maxlength="1000" @change="enableNeedConfirmAlert" style="height: 150px;"></textarea>
									<template v-if="typeof this.createFormState.errors.memo != undefined">
										<template v-for="(error,index) in this.createFormState.errors.memo">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-overflow-hidden">
							<div class="uk-margin">
								<label class="uk-form-label" for="edit_event_form_signage_display_text">サイネージ表示内容<br><span style="color: red">入力した内容はサイネージ画面に表示されます</span></label>
								<div class="uk-form-controls">
									<textarea class="uk-textarea" id="edit_event_form_signage_display_text" name="signage_display_text" type="text" placeholder="サイネージ表示内容を入力してください" maxlength="100" style="background: #ffe4e1" @change="enableNeedConfirmAlert"></textarea>
									<template v-if="typeof this.createFormState.errors.signage_display_tex != undefined">
										<template v-for="(error,index) in this.createFormState.errors.signage_display_tex">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-margin">
							<div class="uk-text-center">
								<p id="edit_evet_dialog_elapsed_time">経過時間 00分00分</p>
							</div>
						</div>
						<div class="uk-margin">
							<div class="uk-text-center">
								<button class="start_button uk-button uk-button-default" type="button" @click="clickEditStartButton">開始</button>
								<button class="extenson_button uk-button uk-button-default uk-button-small uk-margin-left" type="button" @click="clickEditExtensionButton">延長</button>
								<button class="help_button uk-button uk-button-default uk-button-small uk-margin-left" type="button" @click="clickEditHelpButton">ヘルプ</button>
								<button class="end_button uk-button uk-button-default uk-margin-left" type="button" @click="clickEditFinishButton">終了</button>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary uk-margin-top" type="button" @click="saveEditEventForm">保存</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ EditEventDialog -->

		<!-- TodoListDialog -->
		<div id="todo_list_dialog" class="uk-modal-container" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">ToDoリスト</h2>
					</div>
					<div class="uk-align-right">
						<button class="uk-modal-close uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<table class="uk-table">
					<thead>
					<tr>
						<th>カテゴリ</th>
						<th class="uk-text-capitalize">ToDo</th>
						<th>所要時間</th>
						<th>担当</th>
						<th>期限</th>
						<th>完了</th>
						<th>削除</th>
					</tr>
					</thead>
					<tbody>
					<template v-if="staff_todos != null">
						<template v-for="(staff_todo, index) in staff_todos">
							<tr :key="index">
								<td>{{ staff_todo.todo_type.name }}</td>
								<td>
									<template v-if="staff_todo.name != null">
										{{ staff_todo.name }}
									</template>
								</td>
								<td>{{ staff_todo.duration_minute }}</td>
								<td>
									<template v-if="staff_todo.staff != null">
										{{ staff_todo.staff.name }}
									</template>
								</td>
								<td>{{ staff_todo.deadline | deadline_moment }}</td>
								<td>
									<button class="uk-button uk-button-small uk-button-default" @click="doneStaffTodo(staff_todo.id)">完了</button>
								</td>
								<td>
									<button class="uk-button uk-button-small uk-button-default" @click="deleteStaffTodo(staff_todo.id)">削除</button>
								</td>
							</tr>
						</template>
					</template>
					</tbody>
				</table>
			</div>
		</div>
		<!--/ TodoListDialog -->

		<!-- CreateTodoDialog -->
		<div id="create_todo_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">ToDo登録</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_todo_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<div class="uk-form-horizontal">
					<div class="uk-margin">
						<label class="uk-form-label" for="create_todo_dialog_todo_type">カテゴリ (必須)</label>
						<div class="uk-form-controls">
							<select id="create_todo_dialog_todo_type" class="uk-select" name="todo_type" @change="enableNeedConfirmAlert">
								<template v-for="(todo_type,index) in todo_types">
									<option v-bind:value="todo_type.id" :key="index">{{ todo_type.name }}</option>
								</template>
							</select>
							<template v-if="typeof this.createFormState.errors.todo_type_id != undefined">
								<template v-for="(error,index) in this.createFormState.errors.todo_type_id">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="create_todo_dialog_name">ToDo</label>
						<div class="uk-form-controls">
							<input id="create_todo_dialog_name" class="uk-input" name="name" type="text" @change="enableNeedConfirmAlert">
							<template v-if="typeof this.createFormState.errors.name != undefined">
								<template v-for="(error,index) in this.createFormState.errors.name">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="create_todo_dialog_deadline">期限日 (必須)</label>
						<div class="uk-form-controls">
							<template v-if="isMobile()">
								<el-date-picker id="create_todo_dialog_deadline" name="deadline" v-model="create_todo_deadline" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="enableNeedConfirmAlert"></el-date-picker>
							</template>
							<template v-else>
								<el-date-picker id="create_todo_dialog_deadline" name="deadline" v-model="create_todo_deadline" format="yyyy/MM/dd" :type="date" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="enableNeedConfirmAlert"></el-date-picker>
							</template>
							<!-- <select id="create_todo_dialog_deadline" class="uk-select" name="deadline" @change="enableNeedConfirmAlert">
								<template v-for="(date, index) in select_box_date_list">
									<option :value="date" :key="index">{{ date }}</option>
								</template>
							</select> -->
							<template v-if="typeof this.createFormState.errors.date != undefined">
								<template v-for="(error,index) in this.createFormState.errors.deadline">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="create_todo_dialog_deadline_time">期限時間 (必須)</label>
						<div class="uk-form-controls">
							<template v-if="isMobile()">
								<el-time-picker id="create_todo_dialog_deadline_time" name="deadline_time" v-model="create_todo_deadline_time" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options"></el-time-picker>
							</template>
							<template v-else>
								<el-time-picker id="create_todo_dialog_deadline_time" name="deadline_time" v-model="create_todo_deadline_time" format="HH:mm" :clearable="false" :picker-options="time_picker_options"></el-time-picker>
							</template>
							<!-- <el-time-select id="create_todo_dialog_deadline_time" v-model="create_todo_deadline_time" :editable="false" :clearable="false" :picker-options="time_select_options" @change="enableNeedConfirmAlert"></el-time-select> -->
							<!-- <select id="create_todo_dialog_deadline_time" class="uk-select" name="deadline_time" @change="enableNeedConfirmAlert">
								<option :value="'00:00'">00:00</option>
								<option :value="'00:30'">00:30</option>
								<template v-for="num in 23">
									<template v-if="num < 10">
										<option :value="'0'+num+':00'" :key="'0'+num+':00'">0{{num}}:00</option>
										<option :value="'0'+num+':30'" :key="'0'+num+':30'">0{{num}}:30</option>
									</template>
									<template v-else>
										<option :value="num+':00'" :key="num+':00'">{{num}}:00</option>
										<option :value="num+':30'" :key="num+':30'">{{num}}:30</option>
									</template>
								</template>
							</select> -->
							<template v-if="typeof this.createFormState.errors.deadline_time != undefined">
								<template v-for="(error,index) in this.createFormState.errors.deadline_time">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="create_todo_dialog_duration_minute">所要時間 (必須)</label>
						<div class="uk-form-controls">
							<input id="create_todo_dialog_duration_minute" class="uk-input" name="duration_minute" type="text" @change="zenkakuToHankaku" maxlength="3" v-on:change="enableNeedConfirmAlert">
							<template v-if="typeof this.createFormState.errors.duration_minute != undefined">
								<template v-for="(error,index) in this.createFormState.errors.duration_minute">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
				</div>
				<button class="uk-button uk-button-primary uk-width-1-1@l" @click="saveTodo">保存</button>
			</div>
		</div>
		<!--/ CreateTodoDialog -->

		<!-- ReservationBreakdownDialog -->
		<div id="reservation_breakdown_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">内訳</h2>
					</div>
					<div class="uk-align-right">
						<button class="uk-modal-close uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<table class="uk-table">
					<thead>
					<tr>
						<th>業務名</th>
						<th>件数</th>
					</tr>
					</thead>
					<tbody>
					<template v-if="reservation_breakdowns != null">
						<template v-for="reservation_breakdown in reservation_breakdowns">
							<tr :key="reservation_breakdown.id">
								<td>{{ reservation_breakdown.name }}</td>
								<td>{{ reservation_breakdown.count}} 件</td>
							</tr>
						</template>
					</template>

					</tbody>
				</table>
			</div>
		</div>
		<!--/ ReservationBreakdownDialog -->

		<div id="staff_daily_shop_job_position_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">役割設定</h2>
					</div>
					<div class="uk-align-right">
						<button class="uk-modal-close uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<div class="uk-margin">
					<select id="daily_shop_job_position" class="uk-select" @change="enableNeedConfirmAlert">
						<option value="-1">選択してください</option>
						<template v-for="staff_shop_job_position in staff_shop_job_positions">
							<option :key="staff_shop_job_position.id" v-bind:value="staff_shop_job_position.shop_job_position.id">{{ staff_shop_job_position.shop_job_position.display_name }}</option>
						</template>
					</select>
					<template v-if="typeof this.createFormState.errors.shop_job_position_id != undefined">
						<template v-for="(error,index) in this.createFormState.errors.shop_job_position_id">
							<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
						</template>
					</template>
				</div>
				<div class="uk-margin">
					<button class="uk-button uk-button-primary uk-width-1-1@l" @click="saveStaffShopDailyJobPositionDailog">保存</button>
				</div>
			</div>
		</div>

		<!-- DeletedReservationDialog -->
		<div id="deleted_reservation_dialog" class="uk-modal-container" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">削除済みの予約枠</h2>
					</div>
					<div class="uk-align-right">
						<button class="uk-modal-close uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<table class="uk-table uk-table-expand uk-table-striped">
					<tr>
						<th>業務名</th>
						<th>担当者</th>
						<th>開始予定時間</th>
						<th>終了予定時間</th>
						<th>操作</th>
					</tr>
					<template v-if="this.deleted_reservations != null">
						<template v-for="reservation in deleted_reservations">
							<tr :key="reservation.id">
								<td>{{ reservation.shop_job_type.display_name }}</td>
								<template v-if="reservation.response_staff != null">
									<td>{{ reservation.response_staff.name }}</td>
								</template>
								<template v-else>
									<td></td>
								</template>
								<td>{{ reservation.date + ' ' + reservation.plan_start_time | moment }}</td>
								<td>{{ reservation.date + ' ' + reservation.plan_end_time | moment }}</td>
								<td>
									<button class="uk-button uk-button-default" @click="restoreReservation(reservation.id)">元に戻す</button>
								</td>
							</tr>
						</template>
					</template>
				</table>
			</div>
		</div>
		<!-- DeletedReservationDialog -->

		<!-- StaffTodoListDialog -->
		<div id="staff_todo_list_dialog" class="uk-modal-container" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">ToDoリスト</h2>
					</div>
					<div class="uk-align-right">
						<button class="uk-modal-close uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<table class="uk-table uk-width-1-1@l">
					<thead>
					<tr>
						<th>カテゴリ</th>
						<th class="uk-text-capitalize">ToDo</th>
						<th>所要時間</th>
						<th>期限</th>
						<th>完了</th>
						<th>削除</th>
					</tr>
					</thead>
					<tbody>
					<template v-for="staff_todo in staff_todo_list_for_dialog">
						<tr :key="staff_todo.id">
							<td>{{ staff_todo.todo_type.name }}</td>
							<td>{{ staff_todo.name }}</td>
							<td>{{ staff_todo.duration_minute }}</td>
							<td>{{ staff_todo.deadline | deadline_moment }}</td>
							<td>
								<button class="uk-button uk-button-small uk-button-default" @click="doneStaffTodo(staff_todo.id)">完了</button>
							</td>
							<td>
								<button class="uk-button uk-button-small uk-button-default" @click="deleteStaffTodo(staff_todo.id)">削除</button>
							</td>
						</tr>
					</template>
					</tbody>
				</table>
				<button class="uk-button uk-button-primary uk-margin-small-top uk-width-1-1@l" @click="showCreateTodoDialog">作成</button>
			</div>
		</div>
		<!--/ StaffTodoListDialog -->

		<!-- AddStaffFormDialog -->
		<div id="add_staff_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="add_staff_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="add_staff_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin">
							<label class="uk-form-label" for="add_staff_form_staff">スタッフ (必須)</label>
							<div class="uk-form-controls">
								<select id="add_staff_form_staff" class="uk-select" name="staff" @change="enableNeedConfirmAlert">
									<template v-for="staff in staffs">
										<option :key="staff.id" :value="staff.id">{{ staff.name }}</option>
									</template>
								</select>
								<template v-if="typeof this.createFormState.errors.staff_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.staff_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="add_staff_form_date">出勤日 (必須)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-date-picker id="add_staff_form_date" name="date" v-model="add_staff_date_picker" format="yyyy/MM/dd" :type="date" :editable="false" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="enableNeedConfirmAlert"></el-date-picker>
								</template>
								<template v-else>
									<el-date-picker id="add_staff_form_date" name="date" v-model="add_staff_date_picker" format="yyyy/MM/dd" :type="date" :clearable="false" :picker-options="date_picker_options" placeholder="YYYY/MM/DD" @change="enableNeedConfirmAlert"></el-date-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.date != undefined">
									<template v-for="(error,index) in this.createFormState.errors.date">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="add_staff_form_start">出勤時間 (必須)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="add_staff_form_start" v-model="add_staff_dialog_start_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="add_staff_form_start" v-model="add_staff_dialog_start_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.start != undefined">
									<template v-for="(error,index) in this.createFormState.errors.start">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="add_staff_form_end">退勤時間 (必須)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="add_staff_form_end" v-model="add_staff_dialog_end_time_picker" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="add_staff_form_end" v-model="add_staff_dialog_end_time_picker" format="HH:mm" :clearable="false" :picker-options="time_picker_options"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.end != undefined">
									<template v-for="(error,index) in this.createFormState.errors.end">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveAddStaffFormDialog">追加</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ add_staffFormDialog -->

		<!-- LockMode -->
		<template v-if="is_lock_mode">
			<template v-if="current_staff != null">
				<div id="lock_mode">
					<div id="overlay"></div>
					<div class="form">
						<div class="uk-margin">
							<p>{{ current_staff.name }}としてログイン中</p>
							<p>パスワードを入力してください</p>
							<label class="uk-form-label" for="lock_mode_password">パスワード</label>
							<div class="uk-form-controls">
								<input id="lock_mode_password" class="uk-input" type="password">
							</div>
						</div>
						<button class="uk-width-1-1@l uk-button uk-button-default" @click="unlock">ロック解除</button>
					</div>
				</div>
				<!--/ LockMode -->
			</template>
		</template>

		<div id="change_lane_type_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">区分設定</h2>
					</div>
					<div class="uk-align-right">
						<button id="change_lane_type_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<div class="uk-margin">
					<select class="uk-select" name="lane_type" @change="enableNeedConfirmAlert">
						<option value="0">選択なし</option>
						<option value="1">予約</option>
						<option value="2">本日の教室</option>
						<option value="3">次回の教室</option>
					</select>
				</div>
				<div class="uk-margin">
					<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary uk-margin-top" type="button" @click="saveChangeLaneType">保存</button>
				</div>
			</div>
		</div>

		<div id="dialog_space"></div>

		<div class="data_storage">
			<input id="all_receive_noftification" type="hidden" value="false">
			<input id="reservation_delete_mode" type="hidden" value="false">
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {DayPilot, DayPilotCalendar} from 'daypilot-pro-vue'
	import Shop from '@/api/Shop'
	// import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm'
	import StaffWorkSchedule from '@/api/StaffWorkSchedule'
	import StaffTodo from '@/api/StaffTodo'
	import Role from '@/api/Role'
	import ShopJobType from '@/api/ShopJobType'
	import ShopReservation from '@/api/ShopReservation'
	import StaffAuth from '@/api/StaffAuth'
	import StaffDailyShopJobPosition from '@/api/StaffDailyShopJobPosition'
	import Notification from '@/api/Notification'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import ShopJobPosition from '@/api/ShopJobPosition'
	import StaffShopSkillAttribute from '@/api/StaffShopSkillAttribute'
	import TodoType from '@/api/TodoType'
	import RoleService from '@/services/RoleService'
	import Staff from '@/api/Staff'
	import StaffShopJobPosition from '@/api/StaffShopJobPosition'
	import ReservationData from '@/api/ReservationData'
	// import TimePicker from 'vue2-timepicker'

	let _roles = []
	let start_count_up_id = null
	let is_refreshable = true
	let last_moved_time = null
	let cron_count = 0

	let editFormDialogStopCountUp = function () {
		clearInterval(start_count_up_id)
	}

	let editFormDialogStartCountUp = function (start) {
		editFormDialogStopCountUp()

		let startedTime = start

		start_count_up_id = setInterval(async function () {
			let now = moment().utc()
			let countFrom = moment(startedTime).utc()
			let timeDifference = parseInt((now - countFrom) / 1000)
			let mins = parseInt(timeDifference / 60)
			let secs = timeDifference % 60

			$('#edit_evet_dialog_elapsed_time').text('経過時間 ' + mins + '分' + secs + '秒')
		}, 1000)
	}

	let getElasedTime = function (data) {
		if (data.actual_start_time == null) {
			return '経過時間 00分00秒'
		}
		let start = moment(data.actual_start_time).utc()
		let now = moment().utc()
		if (data.status == 2) {
			if (data.actual_end_time != undefined) {
				if (data.actual_end_time != null) {
					now = moment(data.actual_end_time).utc()
				}
			}
		}
		let diff = parseInt((now - start) / 1000)
		let min = parseInt(diff / 60)
		let sec = diff % 60
		return '経過時間 ' + min + '分' + sec + '秒'
	}

	export default {
		name: 'ReservationListPage',
		components: {DayPilot, DayPilotCalendar},
		data () {
			return {
				add_staff_date_picker: moment().format('YYYY/MM/DD'),
				add_staff_dialog_start_time_picker: moment().hour(0).minutes(0),
				add_staff_dialog_end_time_picker: moment().hour(0).minutes(0),
				create_event_date_picker: moment().format('YYYY/MM/DD'),
				create_reservation_dialog_start_time_picker: moment().hour(0).minutes(0),
				create_reservation_dialog_end_time_picker: moment().hour(0).minutes(0),
				edit_event_date_picker: moment().format('YYYY/MM/DD'),
				edit_reservation_dialog_start_time_picker: moment().hour(0).minutes(0),
				edit_reservation_dialog_end_time_picker: moment().hour(0).minutes(0),
				create_todo_deadline: moment().format('YYYY/MM/DD'),
				create_todo_deadline_time: moment().hour(0).minutes(0),
				scheduler_scroll_count: 0,
				staff_list_scroll: {
					target_first_y: 0,
					target_first_x: 0,
					target_first_height: 0
				},
				staff_shop_job_positions: [],
				need_confirm_alert: false,
				select_box_date_list: [],
				target_date: null,
				is_reloadable: true,
				is_staff_list_minimum: false,
				is_minimum_list_mode: false,
				is_display_staff_skill_attributes: false,
				is_all_receive_notification: false,
				receive_notification_mode: 'mine',
				is_lock_mode: false,
				is_reservation_delete_mode: false,
				reservation_breakdowns: [],
				deleted_reservations: [],
				staff_today_shop_job_positions: [],
				ex_staff_today_shop_job_positions: [],
				staff_todo_count: [],
				staff_todos: [],
				staff_todo_list_for_dialog: [],
				staffs: [],
				todo_types: [],
				staff_skill_attributes: [],
				shop_reservations: [],
				work_schedules: [],
				work_staffs: [],
				work_staff_select: '',
				work_sub_staffs: [],
				work_sub_staff_select: '',
				headerStaffId: [],
				calendar_header_list: [],
				reservation_total: 0, // 予約総数
				shop: null,
				shop_job_types: [],
				shop_job_positions: [],
				roles: [],
				current_staff: null,
				createFormState: {
					errors: []
				},
				params: {
					shop_id: null,
					date: moment().format('YYYY-MM-DD')
				},
				daypilot: {
					config: {
						startDate: this.$route.params.date,
						locale: 'ja-jp',
						columnWidthSpec: 'Fixed',
						columnWidth: 120,
						heightSpec: 'Full',
						hourWidth: 120,
						viewType: 'Resources',
						headerLevels: 1,
						headerHeight: 0,
						crosshairType: 'Header',
						cellHeight: 30,
						cellDuration: 15,
						timeHeaderCellDuration: 30,
						rowHeaderScrolling: true,
						timeFormat: 'Clock24Hours',
						businessBeginsHour: 7,
						businessEndsHour: 22,
						dayBeginsHour: 7,
						dayEndsHour: 22,
						tapAndHoldTimeout: 750,
						showCurrentTime: true,
						eventArrangement: 'SideBySide',
						allowEventOverlap: true,
						resizeDisabled: true,
						timeRangeSelectedHandling: 'Enabled',
						eventResizeHandling: 'Update',
						eventClickHandling: 'Update',
						eventDeleteHandling: 'Disabled',
						eventMoveHandling: 'Update',
						eventSelectHandling: 'Disabled',
						onTimeRangeSelected: this.onTimeRangeSelected,
						onTimeRangeSelecting: function (args) {
							is_refreshable = false
						},
						onEventMove: function (args) {
							// is_refreshable = false
							let _args = args

							if (args.newResource == 99999999) {
								// 移動不可列にドロップされた場合はイベントキャンセルする
								args.preventDefault()
								return
							}

							if (RoleService.isNotAdminStaffHigher(_roles)) {
								is_refreshable = true

								return _args.preventCancel()
							} else {
								is_refreshable = false
							}
						},
						onEventMoving: function (args) {
							is_refreshable = false
						},
						onEventMoved: this.onEventMoved,
						onEventClicked: this.onEventClicked,
						onEventResize: function (args) {
							is_refreshable = false
						},
						onEventResizing: function (args) {
							is_refreshable = false
						},
						onEventResized: this.onEventResized,
						onBeforeEventRender: function (args) {
							// 斜線
							let result = args.e.is_end

							if (result) {
								args.e.cssClass = 'background_oblique_line'
							}
							return args
						},
						onBeforeCellRender: function (args) {
							return args
						},
						onAfterRender: this.scrollToCurrentTimeForDP,
						onBeforeTimeHeaderRender: function (args) {
							args.header.html = '<div class="hour" data-hour="' + args.header.start + '" unselectable="on" style="user-select: none;">' + args.header.html + '</div>'
							return args
						}
					}
				},
				date_picker_options: {
					format: 'yyyy/MM/dd'
				},
				time_picker_options: {
					format: 'HH:mm'
				},
				time_select_options: {
					start: '00:00',
					end: '23:30',
					step: '00:30'
				}
			}
		},
		computed: {
			calendar: function () {
				return this.$refs.calendar.control
			},
			toReturnURL: function () { // Todo: 権限によってURLを切り替える
				if (this.roles.is_main_office) {
					return '/shop_search'
				}

				if (this.roles.is_branch_office) {
					return '/shop_search'
				}

				if (this.roles.is_call_center) {
					return '/shop_search'
				}

				if (this.roles.is_admin_staff) {
					return '/shop'
				}

				return '/'
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('HH:mm')
			},
			deadline_moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		watch: {
			is_display_staff_skill_attributes: function () {
				setTimeout(function () {
					if ($('#row_skill_attribute th').hasClass('scrolling_header')) {
						$('#row_skill_attribute th').css('height', $('#row_skill_attribute').innerHeight() + 'px')
					} else {
						$('#row_skill_attribute th').css('height', '')
						$('#row_skill_attribute th').css('line-height')
					}
				}, 100)
			}
		},
		methods: {
			onEventMoved: function (args) {
				let _args = args

				let self = this

				Role.show().then(function (response) {
					let roles = response.data.data

					if (RoleService.isNotAdminStaffHigher(roles)) {
						is_refreshable = true
						return
					}

					StaffAuth.current().then(function (response) {
						let current_staff = response.data.data

						let params = new URLSearchParams()
						params.append('id', _args.e.id())
						params.append('date', moment(_args.newStart.toString()).format('YYYY-MM-DD'))
						params.append('plan_start_time', moment(_args.newStart.toString()).format('HH:mm'))
						params.append('plan_end_time', moment(_args.newEnd.toString()).format('HH:mm'))
						params.append('response_staff_id', _args.newResource)
						params.append('shop_id', self.params.shop_id)

						if (current_staff != null) {
							params.append('last_update_staff_name', current_staff.display_name)
						} else {
							params.append('last_update_staff_name', '不明')
						}

						ShopReservation.update(params).then(function (response) {
							last_moved_time = moment()

							setTimeout(function () {
								is_refreshable = true
							}, 500)

							if (moment(_args.newStart.toString()).isSame(new Date(), 'day') != true) { // 当日じゃない場合
								return
							}

							let reservation_id = response.data.data.id

							StaffAuth.current().then(function (response) {
								let current_staff = response.data.data

								let params = new URLSearchParams()
								params.append('id', reservation_id)

								ShopReservation.one(params).then(function (response) {
									let staff_name = '不明'

									if (current_staff != null) {
										staff_name = current_staff.name
									}

									let params = new URLSearchParams()

									if (response.data.data.sub_response_staff != null) {
										params.append('message', response.data.data.response_staff.name + 'さんと' + response.data.data.sub_response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が変更されました。')
									} else {
										params.append('message', response.data.data.response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が変更されました。')
									}

									params.append('type', 0)
									params.append('to_staff_id', response.data.data.response_staff_id)
									params.append('shop_id', response.data.data.shop_id)

									if (current_staff != null) {
										params.append('from_staff_id', current_staff.id)
									}

									Notification.create(params).then(function () {
									})
								})
							})
						})
					})
				})
			},
			onEventResized: function (args) {
				is_refreshable = false
				let _args = args

				let self = this

				Role.show().then(function (response) {
					let roles = response.data.data

					StaffAuth.current().then(function (response) {
						let current_staff = response.data.data

						let newResponseStaffId = args.e.data.id
						let newStart = moment(_args.newStart.toString()).format('HH:mm')
						let newEnd = moment(_args.newEnd.toString()).format('HH:mm')

						let params = new URLSearchParams()
						params.append('id', _args.e.id())
						params.append('plan_start_time', newStart)
						params.append('plan_end_time', newEnd)
						params.append('response_staff_id', _args.e.data.resource)
						params.append('shop_id', self.params.shop_id)

						if (current_staff != null) {
							params.append('last_update_staff_name', current_staff.display_name)
						} else {
							params.append('last_update_staff_name', '不明')
						}

						ShopReservation.update(params).then(function (response) {
							setTimeout(function () {
								is_refreshable = true
							}, 1000)

							let reservation_id = response.data.data.id

							StaffAuth.current().then(function (response) {
								let current_staff = response.data.data

								let params = new URLSearchParams()
								params.append('id', reservation_id)

								ShopReservation.one(params).then(function (response) {
									let staff_name = '不明'

									if (current_staff != null) {
										staff_name = current_staff.name
									}

									let params = new URLSearchParams()

									if (response.data.data.sub_response_staff != null) {
										params.append('message', response.data.data.response_staff.name + 'さんと' + response.data.data.sub_response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が変更されました。')
									} else {
										params.append('message', response.data.data.response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が変更されました。')
									}

									params.append('type', 0)
									params.append('to_staff_id', response.data.data.response_staff_id)
									params.append('shop_id', response.data.data.shop_id)

									if (current_staff != null) {
										params.append('from_staff_id', current_staff.id)
									}

									Notification.create(params).then(function () {
									})
								})
							})
						})
					})
				})
			},
			enableNeedConfirmAlert (event) {
				this.need_confirm_alert = true
			},
			changeCreateTime () {
				this.need_confirm_alert = true

				if (this.create_event_date_picker == null) {
					this.create_event_date_picker = moment().format('YYYY/MM/DD')
				}
				if (this.create_reservation_dialog_start_time_picker == null) {
					this.create_reservation_dialog_start_time_picker = moment().hour(0).minutes(0)
				}
				if (this.create_reservation_dialog_end_time_picker == null) {
					this.create_reservation_dialog_end_time_picker = moment().hour(0).minutes(0)
				}
			},
			changeEditTime () {
				this.need_confirm_alert = true

				if (this.edit_event_date_picker == null) {
					this.edit_event_date_picker = moment().format('YYYY/MM/DD')
				}
				if (this.edit_reservation_dialog_start_time_picker == null) {
					this.edit_reservation_dialog_start_time_picker = moment().hour(0).minutes(0)
				}
				if (this.edit_reservation_dialog_end_time_picker == null) {
					this.edit_reservation_dialog_end_time_picker = moment().hour(0).minutes(0)
				}
			},
			onTimeRangeSelected: function (args) {
				is_refreshable = true

				let self = this
				let _args = args

				let dp = _args.control
				dp.clearSelection()

				Role.show().then(function (response) {
					let roles = response.data.data

					if (RoleService.isNotAdminStaffHigher(roles)) {
						is_refreshable = true
						return
					}

					self.create_reservation_dialog_start_time_picker = moment(_args.start.toString())

					self.create_reservation_dialog_end_time_picker = moment(_args.end.toString())

					self.create_event_date_picker = moment(_args.start.toString()).format('YYYY-MM-DD')
					// $('#create_event_dialog [name="date"]').val(moment(_args.start.toString()).format('YYYY-MM-DD'))
					$('#create_event_dialog [name="response_staff"] option').prop('selected', false)
					$('#create_event_dialog [name="response_staff"] option[value="' + _args.resource + '"]').prop('selected', true)
					$('#create_event_dialog [name="sub_response_staff"] option').prop('selected', false)
					$('#create_event_dialog [name="shop_job_type"] option').prop('selected', false)
					$('#create_event_dialog [name="reservation_number"]').val('')
					$('#create_event_dialog [name="client_name"]').val('')
					$('#create_event_dialog [name="is_corporation"]').prop('checked', false)
					$('#create_event_dialog [name="memo"]').val('')
					$('#create_event_dialog [name="signage_display_text"]').val('')

					UIkit.modal($('#create_event_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			onEventClicked: function (args) {
				args.preventDefault()

				if (args.originalEvent.constructor.name == 'TouchEvent') {
					return
				}

				let self = this
				let _args = args

				// 出勤情報を元に担当者・対応者リストをリセットする
				self.work_staffs = []
				self.work_sub_staffs = []
				self.work_schedules.forEach(function (value) {
					// Vue.set(self.work_staffs, value.staff.id, value.staff.name)
					self.work_staffs.push({
						id: value.staff.id,
						name: value.staff.name
					})
					self.work_sub_staffs.push({
						id: value.staff.id,
						name: value.staff.name
					})
				})

				if (RoleService.isNotAdminStaffHigher(_roles)) {
					$('#edit_event_dialog [name="date"]').prop('disabled', true)
					$('#edit_event_form_plan_start_time').prop('disabled', true)
					$('#edit_event_form_plan_end_time').prop('disabled', true)
					$('#edit_event_dialog [name="response_staff"]').prop('disabled', true)
					$('#edit_event_dialog [name="sub_response_staff"]').prop('disabled', true)
					$('#edit_event_dialog [name="shop_job_type"]').prop('disabled', true)
					$('#edit_event_dialog [name="is_corporation"]').prop('disabled', true)
					$('#edit_event_dialog [name="signage_display_text"]').prop('disabled', true)
				}

				let params = new URLSearchParams()
				params.append('id', _args.e.id())

				ShopReservation.one(params).then(function (response) {
					let data = response.data.data

					self.edit_reservation_dialog_start_time_picker = moment(data.date + ' ' + data.plan_start_time)

					self.edit_reservation_dialog_end_time_picker = moment(data.date + ' ' + data.plan_end_time)

					$('#edit_event_dialog').data('id', data.id)
					$('#edit_event_dialog').data('response_staff_id', data.response_staff_id)
					$('#edit_event_dialog').data('sub_response_staff_id', data.sub_response_staff_id)

					self.edit_event_date_picker = moment(data.date).format('YYYY-MM-DD')
					$('#edit_event_dialog [name="response_staff"] option').prop('selected', false)
					if (typeof $('#edit_event_dialog [name="response_staff"] option[value="' + data.response_staff_id + '"]').val() === 'undefined') {
						// 勤務情報に存在しない場合は選択肢に追加する
						self.work_staffs.push({
							id: data.response_staff_id,
							name: data.response_staff.name
						})
					}
					self.work_staff_select = data.response_staff_id
					$('#edit_event_dialog [name="sub_response_staff"] option').prop('selected', false)
					if (typeof $('#edit_event_dialog [name="sub_response_staff"] option[value="' + data.sub_response_staff_id + '"]').val() === 'undefined') {
						// 勤務情報に存在しない場合は選択解除する
						self.work_sub_staff_select = null
					} else {
						self.work_sub_staff_select = data.sub_response_staff_id
					}
					$('#edit_event_dialog [name="shop_job_type"] option').prop('selected', false)
					$('#edit_event_dialog [name="shop_job_type"] option[value="' + data.shop_job_type_id + '"]').prop('selected', true)
					$('#edit_event_dialog [name="reservation_number"]').val(data.reservation_number)
					$('#edit_event_dialog [name="client_name"]').val(data.client_name)
					$('#edit_event_dialog [name="is_corporation"]').prop('checked', data.is_corporation == true)
					$('#edit_event_dialog [name="memo"]').val(data.memo)
					$('#edit_event_dialog [name="signage_display_text"]').val(data.signage_display_text)
					$('#edit_event_dialog_last_update_name').text(data.last_update_staff_name)
					$('#edit_event_dialog_last_update_time').text(moment(data.updated_at).format('HH時mm分'))

					let get_elased_time = function (data) {
						if (data.actual_start_time == null) {
							return '経過時間 00分00秒'
						}

						let start = moment(data.actual_start_time).utc()
						let now = moment().utc()

						if (data.status == 2) {
							if (data.actual_end_time != undefined) {
								if (data.actual_end_time != null) {
									now = moment(data.actual_end_time).utc()
								}
							}
						}

						let diff = parseInt((now - start) / 1000)

						let min = parseInt((diff / 60) % 60)
						let sec = diff % 60

						return '経過時間 ' + min + '分' + sec + '秒'
					}

					if (response.data.data.status == 1) {
						let start = moment(response.data.data.actual_start_time).format('YYYY-MM-DD HH:mm:ss')
						editFormDialogStartCountUp(start)
					} else if (response.data.data.status == 2) {
						editFormDialogStopCountUp()
					} else {
						editFormDialogStopCountUp()
					}
					
					$('#edit_evet_dialog_elapsed_time').text(getElasedTime(response.data.data))
					UIkit.modal($('#edit_event_dialog'), {container: '#app div', bgClose: false, stack: true}).show()
				})
			},
			updateShopReservationBreakdowns (reservations) {
				this.reservation_breakdowns = reservations
			},
			isMobile () {
				let ua = navigator.userAgent

				if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Mobile') > 0) {
					return true
				} else {
					return false
				}
			},
			deleteCalendarDefaultShadow () {
				$('.calendar_default_shadow').remove()
			},
			saveChangeLaneType () {
				let self = this
				let id = $('#change_lane_type_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('lane_type', $('#change_lane_type_dialog [name="lane_type"]').val())

				StaffWorkSchedule.update(params).then(response => {
					self.need_confirm_alert = false
					self.loadWorkSchedules()
					self.loadStaffSkillAttributes()
					UIkit.modal($('#change_lane_type_dialog')).hide()
				})
			},
			onClickChangeLaneType (id) {
				let self = this

				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					return
				}

				$('#change_lane_type_dialog').data('id', id)

				let params = new URLSearchParams()
				params.append('id', id)

				StaffWorkSchedule.one(params).then(function (response) {
					let data = response.data.data

					let params = new URLSearchParams()
					params.append('id', data.id)

					$('#change_lane_type_dialog [name="lane_type"] [value="' + data.lane_type + '"]').prop('selected', true)
				})

				UIkit.modal($('#change_lane_type_dialog'), {container: '#app div', bgClose: false}).show()
			},
			scrollToCurrentTimeForDP (args) {
				this.scrollToCurrentTime(true)
			},
			scrollToCurrentTime (checkCount = false) {
				if (checkCount) {
					if (this.scheduler_scroll_count > 0) {
						return
					}
				}

				let threshold = $('#scheduler').offset().top
				let hour_element = $('#scheduler .calendar_default_rowheader_inner .hour[data-hour="' + moment().format('HH:00') + '"]')

				if (hour_element.length > 0) {
					this.scheduler_scroll_count++
					$(window).scrollTop(hour_element.offset().top - (threshold + 120))
				}
			},
			updateStaffListScrollParams () {
				this.staff_list_scroll.target_first_y = $('#staff_list_wrapper').offset().top
				this.staff_list_scroll.target_first_x = $('#staff_list_wrapper').offset().left
				this.staff_list_scroll.target_first_height = $('#staff_list_wrapper').outerHeight()
			},
			/* cronShort: function () {
				let last_moved_time_diff = 0

				if (last_moved_time != null) {
					last_moved_time_diff = moment().diff(last_moved_time, 'seconds')
				} else {
					last_moved_time_diff = 999
				}

				if (is_refreshable && last_moved_time_diff > 3) {
					let result = $(document).find('.calendar_default_shadow_inner')

					if (result.length == 0) {
						let self = this
						let params = new URLSearchParams()
						params.append('shop_id', this.params.shop_id)

						ShopReservation.checkRefresh(params).then(response => {
							if (response.data.data != 0) {
								self.loadEvents()
							}
						})
					}
				}
			}, */
			/* cronLong: function () {
				let result = $(document).find('.calendar_default_shadow_inner')
				if (is_refreshable && result.length == 0) {
					let self = this
					let params = new URLSearchParams()
					params.append('shop_id', this.params.shop_id)
					params.append('status', 0)
					params.append('before_start_date', moment(this.params.date).format('YYYY-MM-DD'))
					params.append('after_start_date', moment(this.params.date).format('YYYY-MM-DD'))
					params.append('q_within_sec', 60)

					StaffWorkSchedule.one(params).then(function (response) {
						if (response.data.data != null) {
							self.loadWorkSchedules() // 出勤情報を取得
							self.loadResources()
							self.loadEvents()
						}
					})
					// self.loadShopReservationCount() // 予約数を取得
					this.loadStaffDailyShopJobPositions() // 当日の役割を取得
					this.loadStaffSkillAttributes() // スキル

					// this.loadStaffTodoCount() // ToDoカウント
				}
			}, */
			cronAll: function () {
				let last_moved_time_diff = 0
				let self = this

				cron_count++

				if (last_moved_time != null) {
					last_moved_time_diff = moment().diff(last_moved_time, 'seconds')
				} else {
					last_moved_time_diff = 999
				}

				if (is_refreshable && last_moved_time_diff > 3) {
					let result = $(document).find('.calendar_default_shadow_inner')

					if (result.length == 0) {
						let cron_last_check_time = localStorage.getItem('cLastCheckTime')
						if (cron_last_check_time == null) {
							cron_last_check_time = moment().format('YYYY-MM-DD HH:mm:ss')
						}
						// データのチェック
						let params = new URLSearchParams()
						params.append('shop_id', this.params.shop_id)
						params.append('last_check_time', cron_last_check_time)
						params.append('check_date', moment(this.params.date).format('YYYY-MM-DD'))
						params.append('ev_not_match_status', 3)
						// ヘッダーデータ
						if (cron_count >= 6) {
							cron_count = 0
							let header_last_check_time = localStorage.getItem('hLastCheckTime')
							if (header_last_check_time == null) {
								header_last_check_time = moment().format('YYYY-MM-DD HH:mm:ss')
							}
							// 30秒に1回ヘッダーデータを取得するためパラメータをつける
							params.append('header_data', true)
							params.append('header_last_check_time', header_last_check_time)
							params.append('ws_status', 0)
						}

						ReservationData.checkData(params).then(response => {
							if (cron_count == 0) {
								// ヘッダーデータ
								if (response.data.ws !== 0) {
									self.checkWorkSchedule(response.data.ws)
								}
								if (response.data.sa !== 0) {
									self.checkSkillAttribute(response.data.sa)
								}
								if (response.data.jp !== 0) {
									self.checkJobPosition(response.data.jp)
								}
								if (response.data.tc !== 0) {
									self.checkToDoCount(response.data.tc)
								}
								// チェック時間を保存する
								localStorage.setItem('hLastCheckTime', response.data.rt)
							}
							// イベントデータ
							if (response.data.ev !== 0) {								
								self.checkEvent(response.data.ev)
							}
							// 通知データ
							if (response.data.notice !== 0) {
								self.checkNotice(response.data.notice)
							}
							// チェック時間を保存する
							localStorage.setItem('cLastCheckTime', response.data.rt)
						})
					}
				}
			},
			refreshScheduler: function () {
				this.initDayPilot() // スケジューラー初期化
				this.loadWorkSchedules() // 出勤情報を取得
				this.loadStaffSkillAttributes() // スキル取得
				// this.loadShopReservationCount() // 予約数を取得
				this.loadStaffDailyShopJobPositions() // 当日の役割を取得
				this.loadStaffTodos() // ToDoを取得
				this.loadStaffTodoCount()
			},
			toDigitalSignage () {
				this.$router.push('/digital_signage')
				location.reload()
			},
			toShopAnotherSearch () {
				this.$router.push('/shop_another_search')
				location.reload()
			},
			getParamDate () {
				return moment(this.params.date).format('YYYY-MM-DD')
			},
			getThreeMonthDateArray () {
				let self = this

				let list_all_date = function (params_start, params_end) {
					let date_list = []
					let start = moment(params_start)
					let end = moment(params_end)

					while (start.diff(end) <= 0) {
						date_list.push(start.format('YYYY-MM-DD'))
						start.add(1, 'days')
					}

					return date_list
				}

				return list_all_date(moment(self.params.date).format('YYYY-MM-DD'), moment(self.params.date).add(1, 'month').endOf('month').format('YYYY-MM-DD'))
			},
			zenkakuToHankaku (event) {
				let event_ = event

				let half = event.target.value.replace(/[！-～]/g,
					function (tmp) {
						return String.fromCharCode(tmp.charCodeAt(0) - 0xFEE0)
					}
				)

				event.target.value = half
			},
			saveAddStaffFormDialog () {
				let self = this

				// let date = $('#add_staff_form_dialog [name="date"]').val()
				let date = moment(self.add_staff_date_picker).format('YYYY/MM/DD')
				let start = moment(self.add_staff_dialog_start_time_picker).format('HH:mm')
				let end = moment(self.add_staff_dialog_end_time_picker).format('HH:mm')
				let staff_id = $('#add_staff_form_dialog [name="staff"]').val()
				// let order_by = Object.keys(self.work_schedules).length
				let order_by = 99999

				let params = new URLSearchParams()
				params.append('start', moment(date + ' ' + start).format('YYYY-MM-DD HH:mm:ss'))
				params.append('end', moment(date + ' ' + end).format('YYYY-MM-DD HH:mm:ss'))
				params.append('staff_id', staff_id)
				params.append('shop_id', self.params.shop_id)
				params.append('order_by', order_by)

				let params_tmp = new URLSearchParams()
				params_tmp.append('before_start_date', moment(date + ' ' + start).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
				params_tmp.append('after_start_date', moment(date + ' ' + start).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
				params_tmp.append('staff_id', staff_id)

				StaffWorkSchedule.all(params_tmp).then(function (response) {
					self.need_confirm_alert = false

					if (response.data.data != 0) {
						alert('出勤情報が重複するため追加できません。')
					} else {
						StaffWorkSchedule.create(params).then(function (response) {
							self.createFormState.errors = []
							alert('保存完了')
							self.refreshScheduler()
							UIkit.modal($('#add_staff_form_dialog'), {container: '#app div', bgClose: false}).hide()
						}).catch(function (error) {
							if (error.response.status == '400') {
								if (error.response.data.message == 'NOT EXISTS STAFF') {
									alert('対象スタッフが存在しないため追加できません。\nダイアログを閉じ画面を更新してから、再度実行してください。')
								} else {
									alert(error.response.data.message)
								}
							} else {
								self.createFormState.errors = error.response.data.errors
							}
						})
					}
				})
			},
			repairFromEditFormCache () {
				let cache = JSON.parse(localStorage.getItem('cache_edit_form'))

				this.edit_reservation_dialog_start_time_picker = moment(cache.date + ' ' + cache.plan_start_time)

				this.edit_reservation_dialog_end_time_picker = moment(cache.date + ' ' + cache.plan_end_time)

				$('#edit_event_dialog').data('id', cache.id)
				$('#edit_event_dialog [name="date"]').val(cache.date)
				$('#edit_event_dialog [name="response_staff"] option[value="' + cache.response_staff_id + '"]').prop('selected', true)
				$('#edit_event_dialog [name="sub_response_staff"] option[value="' + cache.sub_response_staff_id + '"]').prop('selected', true)
				$('#edit_event_dialog [name="shop_job_type"] option[value="' + cache.shop_job_type + '"]').prop('selected', true)
				$('#edit_event_dialog [name="reservation_number"]').val(cache.reservation_number)
				$('#edit_event_dialog [name="memo"]').val(cache.memo)
				$('#edit_event_dialog [name="signage_display_text"]').val(cache.signage_display_text)
				$('#edit_event_dialog [name="client_name"]').val(cache.client_name)

				if (cache.is_corporation == true) {
					$('#edit_event_dialog [name="is_corporation"]').prop('checked', true)
				}

				Role.show().then(function (response) {
					let roles = response.data.data

					if (RoleService.isNotAdminStaffHigher(roles)) {
						$('#edit_event_dialog [name="date"]').prop('disabled', true)
						$('#edit_event_dialog [name="plan_start_time"]').prop('disabled', true)
						$('#edit_event_dialog [name="plan_end_time"]').prop('disabled', true)
						$('#edit_event_dialog [name="response_staff"]').prop('disabled', true)
						$('#edit_event_dialog [name="sub_response_staff"]').prop('disabled', true)
						$('#edit_event_dialog [name="shop_job_type"]').prop('disabled', true)
						$('#edit_event_dialog [name="is_corporation"]').prop('disabled', true)
						$('#edit_event_dialog [name="signage_display_text"]').prop('disabled', true)
					}

					let params = new URLSearchParams()
					params.append('id', cache.id)

					ShopReservation.one(params).then(function (response) {
						let data = response.data.data
						if (response.data.data.status == 1) {
							let start = moment(response.data.data.actual_start_time).format('YYYY-MM-DD HH:mm:ss')
							editFormDialogStartCountUp(start)
						} else if (response.data.data.status == 2) {
							editFormDialogStopCountUp()
						} else {
							editFormDialogStopCountUp()
						}

						$('#edit_evet_dialog_elapsed_time').text(getElasedTime(response.data.data))
						UIkit.modal($('#edit_event_dialog'), {container: '#app div', bgClose: false}).show()
					})
				})
			},
			cacheEditForm () {
				let id = $('#edit_event_dialog').data('id')
				// let date = $('#edit_event_dialog [name="date"]').val()
				let date = moment(this.edit_event_date_picker).format('YYYY/MM/DD')
				let plan_start_time = moment(this.edit_reservation_dialog_start_time_picker).format('HH:mm')
				let plan_end_time = moment(this.edit_reservation_dialog_end_time_picker).format('HH:mm')
				let response_staff_id = $('#edit_event_dialog [name="response_staff"] option:selected').val()
				let sub_response_staff_id = $('#edit_event_dialog [name="sub_response_staff"] option:selected').val()
				let shop_job_type_id = $('#edit_event_dialog [name="shop_job_type"] option:selected').val()
				let reservation_number = $('#edit_event_dialog [name="reservation_number"]').val()
				let is_corporation = $('#edit_event_dialog [name="is_corporation"]').prop('checked')
				let memo = $('#edit_event_dialog [name="memo"]').val()
				let signage_display_text = $('#edit_event_dialog [name="signage_display_text"]').val()
				let client_name = $('#edit_event_dialog [name="client_name"]').val()

				localStorage.setItem('cache_edit_form', JSON.stringify({
					id: id,
					date: date,
					plan_start_time: plan_start_time,
					plan_end_time: plan_end_time,
					response_staff_id: response_staff_id,
					sub_response_staff_id: sub_response_staff_id,
					shop_job_type_id: shop_job_type_id,
					reservation_number: reservation_number,
					is_corporation: is_corporation,
					memo: memo,
					signage_display_text: signage_display_text,
					client_name: client_name
				}))
			},
			deleteStaffTodo (id) {
				let self = this

				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					if (self.current_staff == null) {
						alert('権限がありません')
						return
					}

					if (self.current_staff.id != $('#staff_todo_list_dialog').data('id')) {
						alert('権限がありません')
						return
					}
				}

				let params = new URLSearchParams()
				params.append('id', id)

				if (window.confirm('本当に削除しますか？')) {
					StaffTodo.delete(params).then(function (response) {
						self.loadWorkSchedules()
						self.loadStaffSkillAttributes()
						self.loadStaffTodos()
						self.loadStaffTodoCount()
						UIkit.modal($('#staff_todo_list_dialog')).hide()
					})
				}
			},
			doneStaffTodo (id) {
				let self = this

				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					if (self.current_staff == null) {
						alert('権限がありません')
						return
					}

					if (self.current_staff.id != $('#staff_todo_list_dialog').data('id')) {
						alert('権限がありません')
						return
					}
				}

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('status', 1)

				StaffTodo.update(params).then(function (response) {
					self.loadWorkSchedules()
					self.loadStaffSkillAttributes()
					self.loadStaffTodos()
					self.loadStaffTodoCount()
					UIkit.modal($('#staff_todo_list_dialog')).hide()
				})
			},
			staffTodoDialog (id) {
				let staff_id = id
				let self = this

				$('#staff_todo_list_dialog').data('id', staff_id)
				UIkit.modal($('#staff_todo_list_dialog'), {container: '#app div', bgClose: false}).show()

				let params = new URLSearchParams()
				params.append('staff_id', id)
				params.append('status', 0)
				params.append('order_by_deadline_asc', true)

				StaffTodo.all(params).then(function (response) {
					self.staff_todo_list_for_dialog = response.data.data
					self.staff_todo_count[staff_id] = response.data.data.length
				})
			},
			restoreReservation (id) {
				let self = this

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('shop_id', self.params.shop_id)
				params.append('status', 0)

				if (this.current_staff != null) {
					params.append('last_update_staff_name', this.current_staff.display_name)
				} else {
					params.append('last_update_staff_name', '不明')
				}

				ShopReservation.update(params).then(function (response) {
					UIkit.modal($('#deleted_reservation_dialog')).hide()
					location.reload()
				})
			},
			loadDeletedReservations () {
				let self = this

				let params = new URLSearchParams()
				params.append('shop_id', self.params.shop_id)
				params.append('before_date', moment(self.params.date).format('YYYY-MM-DD'))
				params.append('after_date', moment(self.params.date).format('YYYY-MM-DD'))
				params.append('status', 3)
				params.append('limit', 20)

				ShopReservation.all(params).then(function (response) {
					self.deleted_reservations = response.data.data
				})
			},
			onClickShowDeletedReservations () {
				UIkit.modal($('#deleted_reservation_dialog'), {container: '#app div', bgClose: false}).show()
			},
			onClickAddStaff () {
				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					if (self.current_staff == null) {
						alert('権限がありません')
						return
					}

					if (self.current_staff.id != $('#staff_todo_list_dialog').data('id')) {
						alert('権限がありません')
						return
					}
				}

				if (this.roles.is_call_center) {
					alert('権限がありません')
					return
				}

				UIkit.modal($('#add_staff_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			onClickStaffListToggle () {
				if (this.is_staff_list_minimum) {
					this.is_staff_list_minimum = false
				} else {
					this.is_staff_list_minimum = true
				}

				localStorage.setItem('is_staff_list_minimum', this.is_staff_list_minimum)
				this.updateStaffListScrollParams()
			},
			toggleReserve (id) {
				let self = this

				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					return
				}

				let params = new URLSearchParams()
				params.append('id', id)

				StaffWorkSchedule.one(params).then(function (response) {
					let data = response.data.data

					let params = new URLSearchParams()
					params.append('id', data.id)

					if (data.is_reserve == true) {
						params.append('is_reserve', false)
					} else {
						params.append('is_reserve', true)
					}

					StaffWorkSchedule.update(params).then(function (response) {
						self.refreshScheduler()
					})
				})
			},
			saveTodo () {
				let self = this
				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					if (self.current_staff == null) {
						alert('権限がありません')
						return
					}

					if (self.current_staff.id != $('#create_todo_dialog').data('id')) {
						alert('権限がありません')
						return
					}
				}

				let params = new URLSearchParams()
				params.append('staff_id', $('#create_todo_dialog').data('id'))
				params.append('todo_type_id', $('#create_todo_dialog [name="todo_type"] option:selected').val())
				// params.append('deadline', moment($('#create_todo_dialog [name="deadline"]').val()).format('YYYY-MM-DD'))
				params.append('deadline', moment(this.create_todo_deadline).format('YYYY-MM-DD'))
				// params.append('deadline_time', $('#create_todo_dialog [name="deadline_time"]').val())
				params.append('deadline_time', moment(this.create_todo_deadline_time).format('HH:mm'))
				params.append('duration_minute', $('#create_todo_dialog [name="duration_minute"]').val())
				params.append('shop_id', this.params.shop_id)

				if ($('#create_todo_dialog [name="name"]').val() != '') {
					params.append('name', $('#create_todo_dialog [name="name"]').val())
				}

				StaffTodo.create(params).then(function (response) {
					self.need_confirm_alert = false
					self.createFormState.errors = []
					self.loadStaffTodoCount()
					UIkit.modal($('#create_todo_dialog')).hide()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			loadTodoTypes () {
				let self = this

				let params = new URLSearchParams()
				params.append('status', 0)

				TodoType.all(params).then(function (response) {
					self.todo_types = response.data.data
				})
			},
			showCreateTodoDialog () {
				$('#create_todo_dialog [name="todo_type"] option:selected').prop('selected', false)
				$('#create_todo_dialog [name="name"]').val('')
				$('#create_todo_dialog [name="deadline"] option[value="' + this.target_date + '"]').prop('selected', true)
				$('#create_todo_dialog [name="deadline_time"] option:selected').prop('selected', false)
				$('#create_todo_dialog [name="duration_minute"]').val('')

				let self = this

				$('#create_todo_dialog').data('id', $('#staff_todo_list_dialog').data('id'))

				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					if (self.current_staff == null) {
						alert('権限がありません')
						return
					}

					if (self.current_staff.id != $('#create_todo_dialog').data('id')) {
						alert('権限がありません')
						return
					}
				}

				UIkit.modal($('#create_todo_dialog'), {container: '#app div', bgClose: false}).show()
			},
			toggleStaffSkillAttributes () {
				if (this.is_display_staff_skill_attributes) {
					this.is_display_staff_skill_attributes = false
					$('#row_skill_attribute th').css('height', '')
					$('#row_skill_attribute th').css('line-height', '')
				} else {
					this.is_display_staff_skill_attributes = true
					$('#row_skill_attribute th').css('height', $('#row_skill_attribute').innerHeight() + 'px')
				}
			},
			saveStaffShopDailyJobPositionDailog () {
				let self = this

				StaffAuth.current().then(function (response) {
					let current_staff = response.data.data

					if (RoleService.isNotAdminStaffHigher(self.roles)) {
						if (self.current_staff == null) {
							return
						}

						if (current_staff.id != $('#create_todo_dialog').data('id')) {
							return
						}
					}

					let params = new URLSearchParams()
					params.append('staff_id', $('#staff_daily_shop_job_position_dialog').data('id'))
					params.append('date', moment(self.params.date).format('YYYY-MM-DD'))

					StaffDailyShopJobPosition.delete(params).then(function (response) {
						self.need_confirm_alert = false
						params.append('staff_id', $('#staff_daily_shop_job_position_dialog').data('id'))
						params.append('shop_job_position_id', $('#daily_shop_job_position option:selected').val())
						params.append('date', moment(self.params.date).format('YYYY-MM-DD'))

						if ($('#daily_shop_job_position option:selected').val() != -1) {
							StaffDailyShopJobPosition.create(params).then(function (response) {
								self.createFormState.errors = []
								self.loadStaffDailyShopJobPositions()
								UIkit.modal($('#staff_daily_shop_job_position_dialog')).hide()
							}).catch(function (error) {
								self.createFormState.errors = error.response.data.errors
							})
						} else {
							self.loadStaffDailyShopJobPositions()
							UIkit.modal($('#staff_daily_shop_job_position_dialog')).hide()
						}
					})
				})
			},
			showStaffShopDailyJobPositionDailog (id) {
				let self = this
				this.createFormState.errors = []

				StaffAuth.current().then(function (response) {
					let current_staff = response.data.data

					if (RoleService.isNotAdminStaffHigher(self.roles)) {
						if (self.current_staff == null) {
							return
						}

						if (current_staff.id != $('#create_todo_dialog').data('id')) {
							return
						}
					}

					$('#staff_daily_shop_job_position_dialog').data('id', id)

					let params = new URLSearchParams()
					params.append('staff_id', id)

					StaffShopJobPosition.all(params).then(function (response) {
						self.staff_shop_job_positions = response.data.data
						UIkit.modal($('#staff_daily_shop_job_position_dialog'), {container: '#app div', bgClose: false}).show()
					})
				})
			},
			loadShopJobPositions () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)

				ShopJobPosition.all(params).then(function (response) {
					self.shop_job_positions = response.data.data
				})
			},
			initModeReceiveNotification () {
				$(document).find('#change_mode_receive_notification').hide()
				if (localStorage.getItem('all_receive_noftification') == 'true') {
					this.is_all_receive_notification = true
					$('#all_receive_noftification').val(true)
				} else {
					this.is_reservation_delete_mode = false
					$('#all_receive_noftification').val(false)
				}
			},
			changeModeReceiveNotification () {
				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					return
				}

				if (this.is_all_receive_notification) {
					this.is_all_receive_notification = false
					localStorage.setItem('all_receive_noftification', false)
				} else {
					this.is_all_receive_notification = true
					localStorage.setItem('all_receive_noftification', true)
				}
			},
			clickLogoutButton () {
				let self = this

				Role.show().then(function (response) {
					let role_ = response.data.data

					let return_url = '/'

					if (role_.is_main_office) {
						return_url = '/main_office/login'
					}

					if (role_.is_branch_office) {
						return_url = '/branch_office/login'
					}

					if (role_.is_call_center) {
						return_url = '/call_center/login'
					}

					StaffAuth.logout().then(function (response) {
						// CallCenterAuth.logout().then(function (response) {
							// BranchOfficeAuth.logout().then(function (responase) {
								// MainOfficeAuth.logout().then(function (response) {
									self.$router.push(return_url)
									location.reload()
								// })
							// })
						// })
								})
							})
			},
			showNotificationDialog (id, type, message) {
				let html = ''

				if (type == 0) { // 予約枠変更
					html += '<div class="dialog change_dialog" data-id="' + id + '">'
				}

				if (type == 1) { // ヘルプ
					html += '<div class="dialog help_dialog" data-id="' + id + '">'
				}

				if (type == 2) { // 延長
					html += '<div class="dialog exitension_dialog" data-id="' + id + '">'
				}

				html += '<div class="header">'
				html += '<div class="uk-align-right">'
				html += '<span class="uk-icon-button" uk-icon="close" onclick="$(this).parent().parent().parent().remove()"></span>'
				html += '</div>'
				html += '</div>'
				html += '<div class="message">' + message + '</div>'
				html += '</div>'
				html += '</div>'

				let old_dialog = $('#dialog_space .dialog').last()

				$('#dialog_space').append(html)

				let dialog = $('#dialog_space .dialog[data-id="' + id + '"]')

				if (old_dialog.length > 0) {
					let top = parseInt(old_dialog.css('top'))
					let left = parseInt(old_dialog.css('left'))

					if ($('#dialog_space .dialog').length % 10 == 0) {
						dialog.css('top', (parent.screen.height / 2 - 240))
						dialog.css('left', (parent.screen.width / 2 - 120))
					} else {
						dialog.css('top', top + 20)
						dialog.css('left', left + 20)
					}
				} else {
					dialog.css('top', (parent.screen.height / 2 - 240))
					dialog.css('left', (parent.screen.width / 2 - 120))
				}
			},
			/* receiveMineNotification () {
				let self = this

				if (self.current_staff != null) {
					setInterval(function () {
						let params = new URLSearchParams()
						params.append('shop_id', self.params.shop_id)

						Notification.receive_mine(params).then(function (response) {
							response.data.data.forEach(function (value) {
								if (localStorage.getItem('notification[' + value.id + ']') == null) {
									if (self.current_staff.id != value.from_staff_id && self.current_staff.id == value.to_staff_id) {
										if ($(document).find('.uk-open').length == 0) {
											if (value.from_staff_id == null) {
												if (value.type == 0) {
													self.showNotificationDialog(value.id, value.type, value.message)
													localStorage.setItem('notification[' + value.id + ']', 'noticed')
												}
											} else {
												self.showNotificationDialog(value.id, value.type, value.message)
												localStorage.setItem('notification[' + value.id + ']', 'noticed')
											}
										}
									}
								}
							})
						})
					}, 6000)
				}
			}, */
			/* receiveAllNotification () {
				let self = this

				if (self.current_staff != null) {
					setInterval(function () {
						let params = new URLSearchParams()
						params.append('shop_id', self.params.shop_id)

						Notification.receive_all(params).then(function (response) {
							if (localStorage.getItem('notification[' + response.data.data.id + ']') == null) {
								response.data.data.forEach(function (value) {
									if (localStorage.getItem('notification[' + value.id + ']') == null) {
										if (self.current_staff.id != value.from_staff_id) {
											if ($(document).find('.uk-open').length == 0) {
												if (self.is_all_receive_notification) {
													self.showNotificationDialog(value.id, value.type, value.message)
													localStorage.setItem('notification[' + value.id + ']', 'noticed')
												} else {
													if (value.to_staff_id == self.current_staff.id) {
														self.showNotificationDialog(value.id, value.type, value.message)
														localStorage.setItem('notification[' + value.id + ']', 'noticed')
													}
												}
											}
										}
									}
								})
							}
						})
					}, 6000)
				}
			}, */
			clickEditStartButton () {
				let self = this
				let reservation_id = $('#edit_event_dialog').data('id')
				// StaffAuth.current().then(function (response) {
					// let current_staff = response.data.data

				let tmp_params = new URLSearchParams()
				tmp_params.append('id', reservation_id)

				let date = moment(self.edit_event_date_picker).format('YYYY-MM-DD')
				let plan_start_time = moment(self.edit_reservation_dialog_start_time_picker).format('HH:mm')
				let plan_end_time = moment(self.edit_reservation_dialog_end_time_picker).format('HH:mm')
				let response_staff_id = $('#edit_event_form [name="response_staff"] option:selected').val()
				let sub_response_staff_id = $('#edit_event_form [name="sub_response_staff"] option:selected').val()
				let shop_job_type_id = $('#edit_event_form [name="shop_job_type"] option:selected').val()
				let reservation_number = $('#edit_event_form [name="reservation_number"]').val()
				let is_corporation = $('#edit_event_form [name="is_corporation"]').prop('checked')
				let memo = $('#edit_event_form [name="memo"]').val()
				let signage_display_text = $('#edit_event_form [name="signage_display_text"]').val()
				let client_name = $('#edit_event_form [name="client_name"]').val()

				let params = new URLSearchParams()
				params.append('id', reservation_id)
				params.append('date', date)
				params.append('plan_start_time', plan_start_time)
				params.append('plan_end_time', plan_end_time)
				params.append('response_staff_id', response_staff_id)
				params.append('reservation_number', reservation_number)
				params.append('is_corporation', is_corporation)
				params.append('memo', memo)
				params.append('signage_display_text', signage_display_text)
				params.append('client_name', client_name)
				params.append('shop_id', self.params.shop_id)
				params.append('shop_job_type_id', shop_job_type_id)
				params.append('actual_start_time', moment().format('YYYY-MM-DD HH:mm:ss'))
				params.append('status', 1)

				if ((sub_response_staff_id != null) && sub_response_staff_id != undefined && sub_response_staff_id != 'null') {
					params.append('sub_response_staff_id', sub_response_staff_id)
				} else {
					params.append('sub_response_staff_id', '')
				}

				if (self.current_staff != null) {
					params.append('last_update_staff_name', self.current_staff.display_name)
				} else {
					params.append('last_update_staff_name', '不明')
				}

				ShopReservation.one(tmp_params).then(function (response) {
					// 本人じゃない場合
					if (self.current_staff != null) {
						if (response.data.data.response_staff_id != self.current_staff.id && self.roles.is_admin_staff != true) {
							alert('権限がありません')
							return
						}
					} else {
						alert('権限がありません')
						return
					}
					editFormDialogStartCountUp(moment().format('YYYY-MM-DD HH:mm:ss'))

					// データ更新
					// self.saveEditEventForm()
					ShopReservation.update(params).then(function (response) {
						self.need_confirm_alert = false
						is_refreshable = true
						self.createFormState.errors = []
						let reservation_id = response.data.data.id
						let params = new URLSearchParams()
						params.append('id', reservation_id)

						UIkit.modal($('#edit_event_dialog')).hide()

						ShopReservation.one(params).then(function (response) {
							let diffData = []
							diffData[0] = response.data.data
							self.loadDiffEvents(diffData)
						})
						// self.loadEvents()
					}).catch(function (error) {
						self.createFormState.errors = error.response.data.errors
					})
				})
				// })
			},
			clickEditExtensionButton () {
				let self = this
				let reservation_id = $('#edit_event_dialog').data('id')

				StaffAuth.current().then(function (response) {
					let current_staff = response.data.data

					let params = new URLSearchParams()
					params.append('id', reservation_id)

					ShopReservation.one(params).then(function (response) {
						let update_params = new URLSearchParams()
						update_params.append('id', response.data.data.id)
						update_params.append('extension_start_time', moment().format('YYYY-MM-DD HH:mm:ss'))
						update_params.append('shop_id', self.params.shop_id)

						if (current_staff != null) {
							update_params.append('last_update_staff_name', current_staff.display_name)
						} else {
							update_params.append('last_update_staff_name', '不明')
						}

						// 本人じゃない場合
						if (current_staff != null) {
							if (response.data.data.response_staff_id != current_staff.id && self.roles.is_admin_staff != true) {
								alert('権限がありません')
								return
							}
						} else {
							alert('権限がありません')
							return
						}

						ShopReservation.update(update_params).then(function (response) {
							if (moment(response.data.data.start_plan_time).isSame(new Date(), 'day') != true) { // 当日じゃない場合
								return
							}

							let staff_name = '不明'

							if (current_staff != null) {
								staff_name = current_staff.name
							}

							let params = new URLSearchParams()
							params.append('message', staff_name + 'さんが接客予定時刻を過ぎそうです。')
							params.append('type', 2)
							params.append('to_staff_id', response.data.data.response_staff_id)
							params.append('shop_id', response.data.data.shop_id)

							if (current_staff != null) {
								params.append('from_staff_id', current_staff.id)
							}

							Notification.create(params).then(function () {
								alert('メッセージを送信しました。')
							})
						})
					})
				})
			},
			clickEditHelpButton () {
				let self = this
				let reservation_id = $('#edit_event_dialog').data('id')

				StaffAuth.current().then(function (response) {
					let current_staff = response.data.data

					let params = new URLSearchParams()
					params.append('id', reservation_id)

					ShopReservation.one(params).then(function (response) {
						let update_params = new URLSearchParams()
						update_params.append('id', response.data.data.id)
						update_params.append('help_count', response.data.data.help_count + 1)
						update_params.append('shop_id', self.params.shop_id)

						if (current_staff != null) {
							update_params.append('last_update_staff_name', current_staff.display_name)
						} else {
							update_params.append('last_update_staff_name', '不明')
						}

						// 本人じゃない場合
						if (current_staff != null) {
							if (response.data.data.response_staff_id != current_staff.id && self.roles.is_admin_staff != true) {
								alert('権限がありません')
								return
							}
						} else {
							alert('権限がありません')
							return
						}

						ShopReservation.update(update_params).then(function (response) {
							if (moment(response.data.data.start_plan_time).isSame(new Date(), 'day') != true) { // 当日じゃない場合
								return
							}

							let staff_name = '不明'

							if (current_staff != null) {
								staff_name = current_staff.name
							}

							let params = new URLSearchParams()
							params.append('message', staff_name + 'さんがお困りです。')
							params.append('type', 1)
							params.append('to_staff_id', response.data.data.response_staff_id)
							params.append('shop_id', response.data.data.shop_id)

							if (current_staff != null) {
								params.append('from_staff_id', current_staff.id)
							}

							Notification.create(params).then(function () {
								alert('メッセージを送信しました。')
							})
						})
					})
				})
			},
			clickEditFinishButton () {
				editFormDialogStopCountUp()
				let self = this
				let reservation_id = $('#edit_event_dialog').data('id')
				// StaffAuth.current().then(function (response) {
					// let current_staff = response.data.data

					let params = new URLSearchParams()
					params.append('id', reservation_id)

					ShopReservation.one(params).then(function (response) {
						// 本人じゃない場合
						if (self.current_staff != null) {
							if (response.data.data.response_staff_id != self.current_staff.id && self.roles.is_admin_staff != true) {
								alert('権限がありません')
								return
							}
						} else {
							alert('権限がありません')
							return
						}
						let date = moment(self.edit_event_date_picker).format('YYYY-MM-DD')
						let plan_start_time = moment(self.edit_reservation_dialog_start_time_picker).format('HH:mm')
						let plan_end_time = moment(self.edit_reservation_dialog_end_time_picker).format('HH:mm')
						let response_staff_id = $('#edit_event_form [name="response_staff"] option:selected').val()
						let sub_response_staff_id = $('#edit_event_form [name="sub_response_staff"] option:selected').val()
						let shop_job_type_id = $('#edit_event_form [name="shop_job_type"] option:selected').val()
						let reservation_number = $('#edit_event_form [name="reservation_number"]').val()
						let is_corporation = $('#edit_event_form [name="is_corporation"]').prop('checked')
						let memo = $('#edit_event_form [name="memo"]').val()
						let signage_display_text = $('#edit_event_form [name="signage_display_text"]').val()
						let client_name = $('#edit_event_form [name="client_name"]').val()

						let params = new URLSearchParams()
						params.append('id', reservation_id)
						params.append('date', date)
						params.append('plan_start_time', plan_start_time)
						params.append('plan_end_time', plan_end_time)
						params.append('response_staff_id', response_staff_id)
						params.append('reservation_number', reservation_number)
						params.append('is_corporation', is_corporation)
						params.append('memo', memo)
						params.append('signage_display_text', signage_display_text)
						params.append('client_name', client_name)
						params.append('shop_id', self.params.shop_id)
						params.append('shop_job_type_id', shop_job_type_id)
						params.append('actual_end_time', moment().format('YYYY-MM-DD HH:mm:ss'))
						params.append('status', 2)

						if ((sub_response_staff_id != null) && sub_response_staff_id != undefined && sub_response_staff_id != 'null') {
							params.append('sub_response_staff_id', sub_response_staff_id)
						} else {
							params.append('sub_response_staff_id', '')
						}

						if (self.current_staff != null) {
							params.append('last_update_staff_name', self.current_staff.display_name)
						} else {
							params.append('last_update_staff_name', '不明')
						}

						// データ更新
						// self.saveEditEventForm()

						ShopReservation.update(params).then(function (response) {
							self.need_confirm_alert = false
							is_refreshable = true
							self.createFormState.errors = []
							// self.loadEvents()
							let reservation_id = response.data.data.id
							let params = new URLSearchParams()
							params.append('id', reservation_id)
							ShopReservation.one(params).then(function (response) {
								let diffData = []
								diffData[0] = response.data.data
								self.loadDiffEvents(diffData)
							})
							self.hideEditEventFormDialog()
						}).catch(function (error) {
							self.createFormState.errors = error.response.data.errors
						})
					})
				// })
			},
			enableLockMode () {
				this.is_lock_mode = true
				localStorage.setItem('is_lock_mode', true)

				// 編集ダイアログが表示されている場合
				if ($('#edit_event_dialog').hasClass('uk-open')) {
					this.cacheEditForm()
					UIkit.modal($('#edit_event_dialog')).hide()
				}
			},
			unlock () {
				let self = this
				let password = $('#lock_mode_password').val()

				StaffAuth.current().then(function (response) {
					let params = new URLSearchParams()
					params.append('staff_number', response.data.data.staff_number)
					params.append('password', password)

					StaffAuth.login(params).then(function (response) {
						if (response.data.data) {
							self.is_lock_mode = false
							localStorage.setItem('is_lock_mode', false)

							// キャッシュ確認
							if (localStorage.getItem('cache_edit_form') != null) {
								self.repairFromEditFormCache()
								localStorage.removeItem('cache_edit_form')
							} else {
								localStorage.removeItem('cache_edit_form')
							}

							// スクロール
							self.scrollToCurrentTime()
						} else {
							alert('パスワードが正しくありません')
						}
					})
				})
			},
			deleteEventButton () {
				let self = this
				this.need_confirm_alert = false

				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					if (self.current_staff == null) {
						return
					}

					if (self.current_staff.id != $('#edit_event_dialog').data('id')) {
						return
					}
				}

				if (window.confirm('本当に削除してもよろしいですか？')) {
					let reservation_id = $('#edit_event_dialog').data('id')
					let params = new URLSearchParams()
					params.append('id', reservation_id)
					params.append('shop_id', self.params.shop_id)
					params.append('status', 3)

					if (self.current_staff != null) {
						params.append('last_update_staff_name', self.current_staff.display_name)
					} else {
						params.append('last_update_staff_name', '不明')
					}

					ShopReservation.update(params).then(function (response) {
						// self.loadEvents()

						let params = new URLSearchParams()
						params.append('id', response.data.data.id)

						ShopReservation.one(params).then(function (response) {
							if (moment(response.data.data.start_plan_time).isSame(new Date(), 'day') != true) { // 当日じゃない場合
								// self.loadEvents()
								UIkit.modal($('#edit_event_dialog')).hide()
								location.reload()
								return
							}

							let staff_name = '不明'

							if (self.current_staff != null) {
								staff_name = self.current_staff.name
							}

							let params = new URLSearchParams()

							if (response.data.data.sub_response_staff != null) {
								params.append('message', response.data.data.response_staff.name + 'さんと' + response.data.data.sub_response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が削除されました。')
							} else {
								params.append('message', response.data.data.response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が削除されました。')
							}

							params.append('type', 0)
							params.append('to_staff_id', response.data.data.response_staff_id)
							params.append('shop_id', response.data.data.shop_id)

							if (self.current_staff != null) {
								params.append('from_staff_id', self.current_staff.id)
							}

							Notification.create(params).then(function () {
								UIkit.modal($('#edit_event_dialog')).hide()
								location.reload()
							})
						})
					})
				}
			},
			initChangeReservationDeleteMode () {
				if (this.roles.is_admin_staff != true || this.roles.is_call_center != true || this.roles.is_branch_office != true || this.roles.is_main_office != true) {
					if (this.current_staff == null) {
						return
					}

					if (this.current_staff.id != $('#create_todo_dialog').data('id')) {
						return
					}
				}

				if (localStorage.getItem('reservation_delete_mode') == 'true') {
					this.is_reservation_delete_mode = true
					$('#reservation_delete_mode').val(true)
					$('#change_reservation_delete_mode').addClass('on')
				} else {
					this.is_reservation_delete_mode = false
					$('#reservation_delete_mode').val(false)
					$('#change_reservation_delete_mode').removeClass('on')
				}
			},
			showReservationBreakdownDialog () {
				this.loadReservationBreakdowns()
				UIkit.modal($('#reservation_breakdown_dialog'), {container: '#app div', bgClose: false}).show()
			},
			loadReservationBreakdowns () {
				let self = this

				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)
				params.append('is_reservation', true)

				ShopJobType.all(params).then(function (response) {
					let local_reservation_breakdowns = []
					self.reservation_breakdowns = local_reservation_breakdowns

					response.data.data.forEach(function (value) {
						let params = new URLSearchParams()
						params.append('shop_id', self.params.shop_id)
						params.append('before_date', moment(self.params.date).format('YYYY-MM-DD'))
						params.append('after_date', moment(self.params.date).format('YYYY-MM-DD'))
						params.append('shop_job_type_id', value.id)
						params.append('not_match_status', 3)

						let shop_job_type = value

						ShopReservation.count(params).then(function (response) {
							if (response.data.data != 0) {
								local_reservation_breakdowns.push({
									id: shop_job_type.id,
									name: shop_job_type.display_name,
									count: response.data.data
								})

								self.reservation_breakdowns = local_reservation_breakdowns
							}
						})
					})
				})
			},
			showTodoListDialog () {
				UIkit.modal($('#todo_list_dialog'), {container: '#app div', bgClose: false}).show()
				this.loadStaffTodos() // ToDoを取得
				this.loadStaffTodoCount() // ToDoカウント
			},
			loadStaffDailyShopJobPositions () {
				let self = this

				let params = new URLSearchParams()
				params.append('date', moment(self.params.date).format('YYYY-MM-DD'))

				StaffDailyShopJobPosition.all(params).then(function (response) {
					let list = []

					response.data.data.forEach(function (value) {
						list[value.staff_id] = value.shop_job_position.display_name
					})

					self.staff_today_shop_job_positions = list
				})
			},
			loadStaffTodoCount () {
				let self = this

				let params = new URLSearchParams()
				params.append('shop_id', self.params.shop_id)
				params.append('status', 0)

				StaffTodo.count_per_staff(params).then(function (response) {
					/* Object.keys(self.staff_todo_count).forEach(function (key) {
						self.staff_todo_count[key] = 'Loading..'
					}) */

					// ToDoカウント0セット
					self.headerStaffId.forEach(function (key) {
						self.staff_todo_count[key] = 0
					})
					response.data.data.forEach(function (value) {
						self.staff_todo_count[value.staff_id] = value.count
						Vue.set(self.staff_todo_count, value.staff_id, value.count)
					})
				})
			},
			onClickArrowLeft () {
				$('#scroll').scrollLeft(0)
				$('.calendar_default_scroll > div > div:last-of-type').scrollLeft(0)
				window.screenLeft = 0
			},
			onClickArrowUp () {
				window.scrollTo('top', 0)
			},
			saveEditEventForm () { // ダイアログ保存
				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					if (this.current_staff == null) {
						return
					}
				}

				let self = this

				// StaffAuth.current().then(function (response) {
					// let staff = response.data.data
					// let date = moment($('#edit_event_form [name="date"]').val()).format('YYYY-MM-DD')
					let date = moment(self.edit_event_date_picker).format('YYYY-MM-DD')
					let plan_start_time = moment(self.edit_reservation_dialog_start_time_picker).format('HH:mm')
					let plan_end_time = moment(self.edit_reservation_dialog_end_time_picker).format('HH:mm')
					let response_staff_id = $('#edit_event_form [name="response_staff"] option:selected').val()
					let sub_response_staff_id = $('#edit_event_form [name="sub_response_staff"] option:selected').val()
					let shop_job_type_id = $('#edit_event_form [name="shop_job_type"] option:selected').val()
					let reservation_number = $('#edit_event_form [name="reservation_number"]').val()
					let is_corporation = $('#edit_event_form [name="is_corporation"]').prop('checked')
					let memo = $('#edit_event_form [name="memo"]').val()
					let signage_display_text = $('#edit_event_form [name="signage_display_text"]').val()
					let client_name = $('#edit_event_form [name="client_name"]').val()

					let params = new URLSearchParams()
					params.append('id', $('#edit_event_dialog').data('id'))
					params.append('date', date)
					params.append('plan_start_time', plan_start_time)
					params.append('plan_end_time', plan_end_time)
					params.append('response_staff_id', response_staff_id)
					params.append('reservation_number', reservation_number)
					params.append('is_corporation', is_corporation)
					params.append('memo', memo)
					params.append('signage_display_text', signage_display_text)
					params.append('client_name', client_name)
					params.append('shop_id', self.shop.id)
					params.append('shop_job_type_id', shop_job_type_id)

					if ((sub_response_staff_id != null) && sub_response_staff_id != undefined && sub_response_staff_id != 'null') {
						params.append('sub_response_staff_id', sub_response_staff_id)
					} else {
						params.append('sub_response_staff_id', '')
					}

					if (self.current_staff != null) {
						params.append('create_staff_id', self.current_staff.id)
						params.append('last_update_staff_name', self.current_staff.display_name)
					} else {
						params.append('last_update_staff_name', '不明')
					}

					// 担当者が不在の場合
					/* let t_params = new URLSearchParams()
					t_params.append('before_start_date', date)
					t_params.append('after_start_date', date)
					t_params.append('staff_id', response_staff_id) */

					if (self.headerStaffId.indexOf(parseInt(response_staff_id)) < 0) {
							alert('指定日は担当者が不在のため追加できません。')
							return
						}

					// StaffWorkSchedule.all(t_params).then(function (response) {
						// if (response.data.data.length == 0) {
							// alert('指定日は担当者が不在のため追加できません。')
							// return
						// }

						ShopReservation.update(params).then(function (response) {
							self.need_confirm_alert = false
							self.createFormState.errors = []
							is_refreshable = true
							// self.loadEvents()
							UIkit.modal($('#edit_event_dialog')).hide()
							editFormDialogStopCountUp()

							if (moment(self.params.date).isSame(new Date(), 'day') != true) { // 当日じゃない場合
								return
							}

							let reservation_id = response.data.data.id

							// StaffAuth.current().then(function (response) {
								// let current_staff = response.data.data

								let params = new URLSearchParams()
								params.append('id', reservation_id)

								ShopReservation.one(params).then(function (response) {
									let diffData = []
									diffData[0] = response.data.data
									self.loadDiffEvents(diffData)

									let staff_name = '不明'

									if (self.current_staff != null) {
										staff_name = self.current_staff.name
									}

									let params = new URLSearchParams()

									if (response.data.data.sub_response_staff != null) {
										params.append('message', response.data.data.response_staff.name + 'さんと' + response.data.data.sub_response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が変更されました。')
									} else {
										params.append('message', response.data.data.response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が変更されました。')
									}

									params.append('type', 0)
									params.append('to_staff_id', response.data.data.response_staff_id)
									params.append('shop_id', response.data.data.shop_id)

									if (self.current_staff != null) {
										params.append('from_staff_id', self.current_staff.id)
									}

									Notification.create(params).then(function () {
										localStorage.removeItem('cache_edit_form')
									})
								})
							// })
						}).catch(function (error) {
							self.createFormState.errors = error.response.data.errors
						})
					// })
				// })
			},
			saveCreateEventForm () { // ダイアログ保存
				this.need_confirm_alert = false

				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					return
				}

				let self = this

				// StaffAuth.current().then(function (response) {
					// let staff = response.data.data
					// let date = moment($('#create_event_form [name="date"]').val()).format('YYYY-MM-DD')
					let date = moment(self.create_event_date_picker).format('YYYY-MM-DD')
					let plan_start_time = moment(self.create_reservation_dialog_start_time_picker).format('HH:mm')
					let plan_end_time = moment(self.create_reservation_dialog_end_time_picker).format('HH:mm')
					let response_staff_id = $('#create_event_form [name="response_staff"] option:selected').val()
					let sub_response_staff_id = $('#create_event_form [name="sub_response_staff"] option:selected').val()
					let shop_job_type_id = $('#create_event_form [name="shop_job_type"] option:selected').val()
					let reservation_number = $('#create_event_form [name="reservation_number"]').val()
					let is_corporation = $('#create_event_form [name="is_corporation"]').prop('checked')
					let memo = $('#create_event_form [name="memo"]').val()
					let signage_display_text = $('#create_event_form [name="signage_display_text"]').val()
					let client_name = $('#create_event_form [name="client_name"]').val()

					let params = new URLSearchParams()
					params.append('date', date)
					params.append('plan_start_time', plan_start_time)
					params.append('plan_end_time', plan_end_time)
					params.append('response_staff_id', response_staff_id)
					params.append('reservation_number', reservation_number)
					params.append('is_corporation', is_corporation)
					params.append('memo', memo)
					params.append('signage_display_text', signage_display_text)
					params.append('client_name', client_name)
					params.append('shop_id', self.shop.id)
					params.append('shop_job_type_id', shop_job_type_id)

					if ((sub_response_staff_id != null) && sub_response_staff_id != undefined && sub_response_staff_id != 'null') {
						params.append('sub_response_staff_id', sub_response_staff_id)
					}

					if (self.current_staff != null) {
						params.append('create_staff_id', self.current_staff.id)
						params.append('last_update_staff_name', self.current_staff.display_name)
					} else {
						params.append('last_update_staff_name', '不明')
					}

					// 担当者が不在の場合
					let t_params = new URLSearchParams()
					t_params.append('before_start_date', date)
					t_params.append('after_start_date', date)
					t_params.append('staff_id', response_staff_id)

					if (self.headerStaffId.indexOf(parseInt(response_staff_id)) < 0) {
							alert('指定日は担当者が不在のため追加できません。')
							return
						}

					// StaffWorkSchedule.all(t_params).then(function (response) {
						// if (response.data.data.length == 0) {
							// alert('指定日は担当者が不在のため追加できません。')
							// return
						// }

						ShopReservation.create(params).then(function (response) {
							self.createFormState.errors = []
							is_refreshable = true
							// self.loadEvents()
							// self.loadShopReservationCount()

							UIkit.modal($('#create_event_dialog')).hide()

							let data = response.data.data

							if (moment(self.params.date).isSame(new Date(), 'day') != true) { // 当日じゃない場合
								return
							}

							let reservation_id = response.data.data.id

							// StaffAuth.current().then(function (response) {
								// let current_staff = response.data.data

								let params = new URLSearchParams()
								params.append('id', reservation_id)

								ShopReservation.one(params).then(function (response) {
									let diffData = []
									diffData[0] = response.data.data
									self.loadDiffEvents(diffData)

									let staff_name = '不明'

									if (self.current_staff != null) {
										staff_name = self.current_staff.name
									}

									let params = new URLSearchParams()

									if (response.data.data.sub_response_staff != null) {
										params.append('message', response.data.data.response_staff.name + 'さんと' + response.data.data.sub_response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が作成されました。')
									} else {
										params.append('message', response.data.data.response_staff.name + 'さんの' + moment(response.data.data.plan_start_time, 'HH:mm').format('HH:mm').toString() + '～' + moment(response.data.data.plan_end_time, 'HH:mm').format('HH:mm').toString() + 'の予約枠が作成されました。')
									}

									params.append('type', 0)
									params.append('to_staff_id', response.data.data.response_staff_id)
									params.append('shop_id', response.data.data.shop_id)

									if (self.current_staff != null) {
										params.append('from_staff_id', self.current_staff.id)
									}

									Notification.create(params).then(function () {
									})
								})
							// })
						}).catch(function (error) {
							console.log(error)
							self.createFormState.errors = error.response.data.errors
						})
					// })
				// })
			},
			showCreateEventFormDialog (args) { // ダイアログ表示
				if (RoleService.isNotAdminStaffHigher(this.roles)) {
					return null
				}

				UIkit.modal($('#create_event_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			hideCreateEventFormDialog () {
				UIkit.modal($('#create_event_form_dialog')).hide()
			},
			hideEditEventFormDialog () {
				UIkit.modal($('#edit_event_dialog')).hide()
				editFormDialogStopCountUp()
			},
			getTodoCountByStaffId (staff_id) {
				let params = new URLSearchParams()
				params.append('staff_id', staff_id)
				params.append('status', 0)

				return StaffTodo.all(params).then(function (response) {
					return response.data.data.length
				})
			},
			/* createHtmlForWorkSchedules () {
				this.work_schedules.forEach(function (value) {
					$('#row_reservation').append('<td width="125px"></td>')
					$('#row_name').append('<td width="125px">' + value.staff.display_name + '</td>')
					$('#row_job_position').append('<td width="125px"></td>')
					$('#row_skill_attribute').append('<td width="125px"></td>')
					$('#row_todo').append('<td width="125px"></td>')
					$('#row_start').append('<td width="125px">' + moment(value.start).format('HH:mm') + '</td>')
					$('#row_end').append('<td width="125px">' + moment(value.end).format('HH:mm') + '</td>')
				})
			}, */
			loadShopReservations () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('before_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('after_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('not_match_status', 3)

				ShopReservation.all(params).then(function (response) {
					self.shop_reservations = response.data.data
				})
			},
			/* loadShopReservationCount () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('before_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('after_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('not_match_status', 3)

				ShopReservation.reservation_type_count(params).then(function (response) {
					self.reservation_total = response.data.data
				})
			}, */
			loadStaffSkillAttributes () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)
				params.append('q_with_staff_shop_skill_attributes', true)

				Staff.all(params).then(function (response) {
					response.data.data.forEach(function (value) {
						let local_shop_attributes = []
						/* value.staff_shop_skill_attributes.forEach(function (_value) {
							local_shop_attributes.push(_value)
							console.log(_value)
						}) */
						local_shop_attributes = value.staff_shop_skill_attributes
						Vue.set(self.staff_skill_attributes, value.id, local_shop_attributes)
					})
				})
			},
			loadWorkSchedules () {
				let self = this
				let todo_count_list = []

				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)
				params.append('before_start_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('after_start_date', moment(this.params.date).format('YYYY-MM-DD'))

				StaffWorkSchedule.all(params).then(function (response) {
					self.work_schedules = response.data.data
					self.work_schedules.forEach(function (value) {
						self.headerStaffId.push(value.staff.id)
					})
					// self.createHtmlForWorkSchedules()
					// self.loadStaffSkillAttributes()
				})
			},
			/* datePickerFormat (date) {
				return moment(date).format('YYYY-MM-DD (dddd)')
			}, */
			selectedDatePicker (date) {
				if (date == null) {
					console.log('date null select')
				} else {
					this.params.date = moment(date).format('YYYY/MM/DD')
					this.$router.push('/reservation_list/' + this.params.shop_id + '/' + moment(date).format('YYYY-MM-DD'))
					location.reload()
				}
			},
			initDisplayMode () {
				if (localStorage.getItem('enableAllDisplayMode') == 'true') {
					$('#scheduler').addClass('minimum_mode')
					localStorage.setItem('enableAllDisplayMode', true)
					this.is_minimum_list_mode = true
				} else {
					localStorage.setItem('enableAllDisplayMode', false)
					$('#scheduler').removeClass('minimum_mode')
					this.is_minimum_list_mode = false
				}
			},
			enableAllDisplayMode () {
				$('#scheduler').addClass('minimum_mode')
				localStorage.setItem('enableAllDisplayMode', true)
				this.is_minimum_list_mode = true

				location.reload()
			},
			disableAllDisplayMode () {
				localStorage.setItem('enableAllDisplayMode', false)
				$('#scheduler').removeClass('minimum_mode')
				this.is_minimum_list_mode = false

				location.reload()
			},
			updateStaffTodoCount () {
				let self = this

				Object.keys(this.staff_todo_count).forEach(function (key) {
					self.staff_todo_count[key] = 0
				})

				this.staff_todos.forEach(function (value) {
					Vue.set(self.staff_todo_count, value.staff_id, self.staff_todo_count[value.staff_id] + 1)
				})
			},
			loadStaffTodos () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)
				params.append('order_by_deadline_asc', true)

				StaffTodo.all(params).then(function (response) {
					self.staff_todos = response.data.data
				})
			},
			loadShopJobTypes () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)

				ShopJobType.all(params).then(function (response) {
					self.shop_job_types = response.data.data
				})
			},
			loadShop () {
				let self = this
				let params = new URLSearchParams()
				params.append('id', this.params.shop_id)

				Shop.one(params).then(function (response) {
					self.shop = response.data.data
				})
			},
			loadCurrentStaff () {
				let self = this

				StaffAuth.current().then(function (response) {
					self.current_staff = response.data.data
				})
			},
			loadRoles () {
				let self = this

				Role.show().then(function (response) {
					self.roles = response.data.data
					_roles = response.data.data
				})
			},
			loadParams () {
				this.params.shop_id = this.$route.params.shop_id

				if (this.$route.params.date != null) {
					this.params.date = moment(this.$route.params.date).format('YYYY-MM-DD')
				}
			},
			initDayPilot () {
				let self = this

				Role.show().then(function (response) {
					if (RoleService.isNotAdminStaffHigher(response.data.data)) {
						self.daypilot.config.eventResizeHandling = 'Disabled'
						self.daypilot.config.eventMoveHandling = 'Disabled'
					}

					// let params = new URLSearchParams()

					// params.append('shop_id', self.params.shop_id)
					// params.append('status', 0)
					// params.append('before_start_date', moment(self.params.date).format('YYYY-MM-DD'))
					// params.append('after_start_date', moment(self.params.date).format('YYYY-MM-DD'))

					// StaffWorkSchedule.all(params).then(function (response) {
							// self.updateOnBeforeCellRender(response.data.data)
							self.loadWorkSchedules() // 出勤情報を取得
							self.loadStaffSkillAttributes() // スキル取得
							self.loadResources()
							is_refreshable = true
							self.loadEvents()
					// })
				})
			},
			initTable () {
				let self = this

				// ヘッダー情報取得
				// 勤務情報取得
				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)
				params.append('before_start_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('after_start_date', moment(this.params.date).format('YYYY-MM-DD'))

				StaffWorkSchedule.all(params).then(function (response) {
					let data = []
					self.work_schedules = response.data.data
					self.work_schedules.forEach(function (value) {
						self.headerStaffId.push(value.staff.id)
					})
					// 描画
					self.work_staffs = []
					self.work_sub_staffs = []
					self.calendar_header_list = []
					self.updateOnBeforeCellRender(self.work_schedules)
					self.work_schedules.forEach(function (value) {
						data.push({
							id: value.staff.id,
							name: value.staff.display_name
						})
						// 出勤スタッフ一覧
						self.work_staffs.push({
							id: value.staff.id,
							name: value.staff.name
						})
						self.work_sub_staffs.push({
							id: value.staff.id,
							name: value.staff.name
						})
						self.calendar_header_list.push({
							id: value.staff.id,
							name: value.staff.display_name
						})
					})
					self.calendar.update({columns: data})

					// イベント描画
					let evparams = new URLSearchParams()
					evparams.append('shop_id', self.params.shop_id)
					evparams.append('before_date', moment(self.params.date).format('YYYY-MM-DD'))
					evparams.append('after_date', moment(self.params.date).format('YYYY-MM-DD'))
					evparams.append('not_match_status', 3)

					let substituteVisible = false

					ShopReservation.all(evparams).then(function (response) {
						let data = []
						let reservation_count = 0

						response.data.data.forEach(function (value) {
							let display_icon = ''
							let resource_id = ''

							if (value.memo != null) {
								display_icon += '<i class="uk-icon icon_design" uk-icon="pencil" unselectable="on" style="user-select: none;"></i>'
							}

							if (value.status == 1) {
								display_icon += '<i class="uk-icon icon_design" uk-icon="user" unselectable="on" style="user-select: none;"></i>'
							}

							if (value.is_corporation == true) {
								display_icon += '<i class="far fa-building" unselectable="on" style="user-select: none;"></i>.'
							}

							display_icon = '<span unselectable="on" style="user-select: none;">' + display_icon + '</span>'

							let display_text = ''

							if (value.client_name != null && value.reservation_number != null) {
								display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
							} else if (value.client_name != null && value.reservation_number == null) {
								display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span>'
							} else if (value.client_name == null && value.reservation_number != null) {
								display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
							} else {
								display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span>'
							}

							if (value.sub_response_staff_id != null && value.sub_response_staff != null) {
								display_text += '<span unselectable="on" style="user-select: none;">' + value.sub_response_staff.display_name + '</span>'
							}

							// 出勤情報に存在するかチェック
							if (self.headerStaffId.indexOf(value.response_staff_id) >= 0) {
								resource_id = value.response_staff_id
							} else {
								resource_id = 99999999
								substituteVisible = true
							}

							data.push({
								id: value.id,
								start: new DayPilot.Date(value.date + ' ' + value.plan_start_time),
								end: new DayPilot.Date(value.date + ' ' + value.plan_end_time),
								text: '<div unselectable="on" style="user-select: none;">' + display_icon + display_text + '</div>',
								resource: resource_id,
								backColor: value.shop_job_type.color.hex,
								is_end: value.status == 2
							})
							if (value.shop_job_type.is_reservation === true) {
								// 予約件数をカウント
								reservation_count++
							}
						})

						let loopCount = 0
						let hitFlg = false
						self.calendar_header_list.forEach(function (val) {
							if (val.id === 99999999) {
								hitFlg = true
								if (substituteVisible === false) {
									self.calendar_header_list.splice(loopCount, 1)
								}
							}
							loopCount++
						})
						if (hitFlg === false && substituteVisible === true) {
							self.calendar_header_list.push({
								id: 99999999,
								name: '勤務情報なし予約データ'
							})
						}
						self.calendar.update({columns: self.calendar_header_list, events: data})
						$('.calendar_default_shadow').remove()
						// 予約総数更新
						self.reservation_total = reservation_count
					})
					self.loadStaffTodoCount()
				})
			},
			updateOnBeforeCellRender (work_schedules) {
				let self = this
				let _work_schedules = work_schedules

				this.daypilot.config.onBeforeCellRender = function (args) {
					let _args = args

					_work_schedules.forEach(function (value) {
						if (value.staff_id == _args.cell.resource) {
							let result = moment(value.start).diff(moment(_args.cell.start.toString())) > 0 || moment(value.end).diff(moment(_args.cell.end.toString())) < 0

							if (result) {
								_args.cell.backColor = '#EFEFEF'
							}
						}
					})
				}
			},
			loadResources () {
				let data = []

				let self = this

				/* let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('status', 0)
				params.append('before_start_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('after_start_date', moment(this.params.date).format('YYYY-MM-DD'))
				*/
				self.work_staffs = []
				self.work_sub_staffs = []
				self.calendar_header_list = []

				// StaffWorkSchedule.all(params).then(function (response) {
					// self.updateOnBeforeCellRender(response.data.data)
					self.updateOnBeforeCellRender(self.work_schedules)

					// response.data.data.forEach(function (value) {
					self.work_schedules.forEach(function (value) {
						data.push({
							id: value.staff.id,
							name: value.staff.display_name
						})
						// 出勤スタッフ一覧
						self.work_staffs.push({
							id: value.staff.id,
							name: value.staff.name
						})
						self.work_sub_staffs.push({
							id: value.staff.id,
							name: value.staff.name
						})
						self.calendar_header_list.push({
							id: value.staff.id,
							name: value.staff.display_name
						})
					})
					self.calendar.update({columns: data})
				// })
			},
			loadEvents () {
				let self = this

				let params = new URLSearchParams()
				params.append('shop_id', this.params.shop_id)
				params.append('before_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('after_date', moment(this.params.date).format('YYYY-MM-DD'))
				params.append('not_match_status', 3)

				let substituteVisible = false
				// ヘッダー情報取得
				/* let headerStaffId = []
				self.work_schedules.forEach(function (value) {
					headerStaffId.push(value.staff.id)
				}) */

				ShopReservation.all(params).then(function (response) {
					let data = []
					let reservation_count = 0

					response.data.data.forEach(function (value) {
						let display_icon = ''
						let resource_id = ''

						if (value.memo != null) {
							display_icon += '<i class="uk-icon icon_design" uk-icon="pencil" unselectable="on" style="user-select: none;"></i>'
						}

						if (value.status == 1) {
							display_icon += '<i class="uk-icon icon_design" uk-icon="user" unselectable="on" style="user-select: none;"></i>'
						}

						if (value.is_corporation == true) {
							display_icon += '<i class="far fa-building" unselectable="on" style="user-select: none;"></i>.'
						}

						display_icon = '<span unselectable="on" style="user-select: none;">' + display_icon + '</span>'

						let display_text = ''

						if (value.client_name != null && value.reservation_number != null) {
							display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
						} else if (value.client_name != null && value.reservation_number == null) {
							display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span>'
						} else if (value.client_name == null && value.reservation_number != null) {
							display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
						} else {
							display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span>'
						}

						if (value.sub_response_staff_id != null && value.sub_response_staff != null) {
							display_text += '<span unselectable="on" style="user-select: none;">' + value.sub_response_staff.display_name + '</span>'
						}

						// 出勤情報に存在するかチェック
						if (self.headerStaffId.indexOf(value.response_staff_id) >= 0) {
							resource_id = value.response_staff_id
						} else {
							resource_id = 99999999
							substituteVisible = true
						}

						data.push({
							id: value.id,
							start: new DayPilot.Date(value.date + ' ' + value.plan_start_time),
							end: new DayPilot.Date(value.date + ' ' + value.plan_end_time),
							text: '<div unselectable="on" style="user-select: none;">' + display_icon + display_text + '</div>',
							resource: resource_id,
							backColor: value.shop_job_type.color.hex,
							is_end: value.status == 2
						})
						if (value.shop_job_type.is_reservation === true) {
							// 予約件数をカウント
							reservation_count++
						}
					})

					if (is_refreshable) {
						let loopCount = 0
						let hitFlg = false
						self.calendar_header_list.forEach(function (val) {
							if (val.id === 99999999) {
								hitFlg = true
								if (substituteVisible === false) {
									self.calendar_header_list.splice(loopCount, 1)
								}
							}
							loopCount++
						})
						if (hitFlg === false && substituteVisible === true) {
							self.calendar_header_list.push({
								id: 99999999,
								name: '勤務情報なし予約データ'
							})
						}
						self.calendar.update({columns: self.calendar_header_list, events: data})
						$('.calendar_default_shadow').remove()
					}
					// 予約総数更新
					self.reservation_total = reservation_count
				})
			},
			checkWorkSchedule (resData) {
				let self = this
				let data = []
				self.work_staffs = []
				self.work_sub_staffs = []
				self.calendar_header_list = []

				self.work_schedules = resData
				self.updateOnBeforeCellRender(self.work_schedules)
				self.work_schedules.forEach(function (value) {
					self.headerStaffId.push(value.staff.id)
					data.push({
						id: value.staff.id,
						name: value.staff.display_name
					})
					// 出勤スタッフ一覧
					self.work_staffs.push({
						id: value.staff.id,
						name: value.staff.name
					})
					self.work_sub_staffs.push({
						id: value.staff.id,
						name: value.staff.name
					})
					self.calendar_header_list.push({
						id: value.staff.id,
						name: value.staff.display_name
					})
				})
				self.calendar.update({columns: data})
			},
			checkEvent (resData) {
				let self = this
				let data = []
				let reservation_count = 0
				let substituteVisible = false
				// データループ
				resData.forEach(function (value) {
					let display_icon = ''
					let resource_id = ''
					if (value.memo != null) {
						display_icon += '<i class="uk-icon icon_design" uk-icon="pencil" unselectable="on" style="user-select: none;"></i>'
					}

					if (value.status == 1) {
						display_icon += '<i class="uk-icon icon_design" uk-icon="user" unselectable="on" style="user-select: none;"></i>'
					}

					if (value.is_corporation == true) {
						display_icon += '<i class="far fa-building" unselectable="on" style="user-select: none;"></i>.'
					}

					display_icon = '<span unselectable="on" style="user-select: none;">' + display_icon + '</span>'

					let display_text = ''
					if (value.client_name != null && value.reservation_number != null) {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
					} else if (value.client_name != null && value.reservation_number == null) {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span>'
					} else if (value.client_name == null && value.reservation_number != null) {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
					} else {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span>'
					}

					if (value.sub_response_staff_id != null && value.sub_response_staff != null) {
						display_text += '<span unselectable="on" style="user-select: none;">' + value.sub_response_staff.display_name + '</span>'
					}

					// 出勤情報に存在するかチェック
					if (self.headerStaffId.indexOf(value.response_staff_id) >= 0) {
						resource_id = value.response_staff_id
					} else {
						resource_id = 99999999
						substituteVisible = true
					}

					data.push({
						id: value.id,
						start: new DayPilot.Date(value.date + ' ' + value.plan_start_time),
						end: new DayPilot.Date(value.date + ' ' + value.plan_end_time),
						text: '<div unselectable="on" style="user-select: none;">' + display_icon + display_text + '</div>',
						resource: resource_id,
						backColor: value.shop_job_type.color.hex,
						is_end: value.status == 2
					})

					if (value.shop_job_type.is_reservation === true) {
						// 予約件数をカウント
						reservation_count++
					}
				})

				let loopCount = 0
				let hitFlg = false
				self.calendar_header_list.forEach(function (val) {
					if (val.id === 99999999) {
						hitFlg = true
						if (substituteVisible === false) {
							self.calendar_header_list.splice(loopCount, 1)
						}
					}
					loopCount++
				})
				if (hitFlg === false && substituteVisible === true) {
					self.calendar_header_list.push({
						id: 99999999,
						name: '勤務情報なし予約データ'
					})
				}
				self.calendar.update({columns: self.calendar_header_list, events: data})
				$('.calendar_default_shadow').remove()
				// 予約総数更新
				self.reservation_total = reservation_count
			},
			checkNotice (resData) {
				let self = this
				let check_mode = 'no'
				if (self.receive_notification_mode == 'mine') {
					// 自分のイベントのみチェック
					check_mode = 'mine'
				} else if (self.receive_notification_mode == 'all') {
					if (self.is_all_receive_notification) {
						// すべてのイベントをチェック
						check_mode = 'all'
					} else {
						// 自分のイベントのみチェック
						check_mode = 'mine'
					}
				}
				// データループ
				resData.forEach(function (value) {
					let check_flg = false
					// 通知チェック
					if (self.current_staff != null) {
						if (check_mode == 'mine') {
							if (self.current_staff.id != value.from_staff_id && self.current_staff.id == value.to_staff_id) {
								check_flg = true
							}
						} else if (check_mode == 'all') {
							// 自分が追加・更新したイベントはチェックしない
							if (self.current_staff.id != value.from_staff_id) {
								check_flg = true
							}
						}
						if (check_flg == true) {
							// 通知するかチェックする
							if ($(document).find('.uk-open').length == 0) {
								self.showNotificationDialog(value.id, value.type, value.message)
							}
						}
					}
				})
			},
			checkToDoCount (resData) {
				let self = this
				// ToDoカウント0セット
				self.headerStaffId.forEach(function (key) {
					self.staff_todo_count[key] = 0
				})
				// データループ
				resData.forEach(function (value) {
					self.staff_todo_count[value.staff_id] = value.count
					Vue.set(self.staff_todo_count, value.staff_id, value.count)
				})
			},
			checkJobPosition (resData) {
				let self = this
				let list = []
				resData.forEach(function (value) {
					list[value.staff_id] = value.shop_job_position.display_name
				})
				self.staff_today_shop_job_positions = list
			},
			checkSkillAttribute (resData) {
				let self = this
				let local_shop_attributes = []
				// self.staff_skill_attributes = []
				resData.forEach(function (value) {
					let local_shop_attributes = []
					local_shop_attributes = value.staff_shop_skill_attributes
					Vue.set(self.staff_skill_attributes, value.id, local_shop_attributes)
				})
			},
			loadDiffEvents (resData) {
				// var proc_start = performance.now()
				let self = this

				let data = []
				resData.forEach(function (value) {
					let display_icon = ''
					if (value.memo != null) {
						display_icon += '<i class="uk-icon icon_design" uk-icon="pencil" unselectable="on" style="user-select: none;"></i>'
					}
					if (value.status == 1) {
						display_icon += '<i class="uk-icon icon_design" uk-icon="user" unselectable="on" style="user-select: none;"></i>'
					}
					if (value.is_corporation == true) {
						display_icon += '<i class="far fa-building" unselectable="on" style="user-select: none;"></i>.'
					}
					display_icon = '<span unselectable="on" style="user-select: none;">' + display_icon + '</span>'
					let display_text = ''
					if (value.client_name != null && value.reservation_number != null) {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
					} else if (value.client_name != null && value.reservation_number == null) {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.client_name + ' 様</span>'
					} else if (value.client_name == null && value.reservation_number != null) {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span><span unselectable="on" style="user-select: none;">' + value.reservation_number + '</span>'
					} else {
						display_text = '<span unselectable="on" style="user-select: none;">' + value.shop_job_type.display_name + '</span>'
					}
					if (value.sub_response_staff_id != null && value.sub_response_staff != null) {
						display_text += '<span unselectable="on" style="user-select: none;">' + value.sub_response_staff.display_name + '</span>'
					}
					let e = self.calendar.events.find(value.id)
					if (e == null) {
						data = ({
							id: value.id,
							start: new DayPilot.Date(value.date + ' ' + value.plan_start_time),
							end: new DayPilot.Date(value.date + ' ' + value.plan_end_time),
							text: '<div unselectable="on" style="user-select: none;">' + display_icon + display_text + '</div>',
							resource: value.response_staff_id,
							backColor: value.shop_job_type.color.hex,
							is_end: value.status == 2
				})
						if (is_refreshable) {
							self.calendar.events.add(data)
							if (value.shop_job_type.is_reservation === true) {
								// 予約件数をカウント
								self.reservation_total++
							}
			}
					} else {
						e.data.start = new DayPilot.Date(value.date + ' ' + value.plan_start_time)
						e.data.end = new DayPilot.Date(value.date + ' ' + value.plan_end_time)
						e.data.text = '<div unselectable="on" style="user-select: none;">' + display_icon + display_text + '</div>'
						e.data.resource = value.response_staff_id
						e.data.backColor = value.shop_job_type.color.hex
						e.data.is_end = value.status == 2
						if (is_refreshable) {
							self.calendar.events.update(e)
						}
					}
				})
				if (is_refreshable) {
					$('.calendar_default_shadow').remove()
				}
				// var proc_end = performance.now()
				// console.log('ex:' + (proc_end - proc_start) + 'ms')
			}
		},
		created () {
			this.loadParams() // URLのパラメータを取得
			this.loadRoles() // 権限チェック
			this.loadCurrentStaff()
			this.loadShop() // 店舗情報取得
			this.loadShopJobTypes() // 業務を取得
			// this.loadWorkSchedules() // 出勤情報取得
			this.loadStaffSkillAttributes() // スキル取得
			// this.loadShopReservationCount() // 予約数を取得

			this.loadTodoTypes()
			// this.loadStaffTodoCount()
			this.loadStaffTodos()
			this.loadStaffDailyShopJobPositions()
			this.loadReservationBreakdowns()
			this.loadShopJobPositions()
			this.loadDeletedReservations()

			this.initDisplayMode()

			if (localStorage.getItem('is_staff_list_minimum') == 'true') {
				this.is_staff_list_minimum = true
			} else if (this.is_minimum_list_mode != true) {
				this.is_staff_list_minimum = false
			}

			if (this.is_minimum_list_mode) {
				this.daypilot.config.columnWidth = 60
				this.daypilot.config.hourWidth = 60
				this.daypilot.config.cellHeight = 14
				this.is_staff_list_minimum = true
			}

			// 出勤情報追加
			let self = this
			let params = new URLSearchParams()
			params.append('shop_id', self.params.shop_id)

			Staff.all(params).then(function (response) {
				self.staffs = response.data.data
			})

			if (localStorage.getItem('is_lock_mode') == 'true') {
				this.is_lock_mode = true
			} else {
				this.is_lock_mode = false
			}

			// 日付
			this.select_box_date_list = this.getThreeMonthDateArray()
			this.target_date = this.getParamDate()
		},
		beforeMount () {
		},
		mounted () {
			let self = this

			if (this.is_minimum_list_mode) {
				$('#staff_list_table').removeClass('normal')
				$('#staff_list_table').addClass('min')
				$('#staff_list_toggle').hide()
			}

			this.initChangeReservationDeleteMode()
			this.initModeReceiveNotification()
			// this.initDayPilot() // DayPilotの初期化
			this.initTable()
			this.updateStaffListScrollParams()

			Role.show().then(function (response) {
				if (RoleService.isNotAdminStaffHigher(response.data.data)) {
					// self.receiveMineNotification()
					self.receive_notification_mode = 'mine'
				} else {
					// self.receiveAllNotification()
					self.receive_notification_mode = 'all'
				}

				let data = response.data

				if (data.data.is_staff != true && data.data.is_admin_staff != true && data.data.is_call_center != true && data.data.is_branch_office != true && data.data.is_main_office != true) { // 権限が無い場合
					self.$router.push('/')
					location.reload()
				}

				if (data.data.is_call_center != true && data.data.is_branch_office != true && data.data.is_main_office != true && data.data.is_staff) {
					StaffAuth.current().then(function (response) {
						if (self.params.shop_id != response.data.data.shop_id) {
							self.$router.push('/')
							location.reload()
						}
					})
				}
			})

			// 追尾スクロール
			$(window).on('load', function () {
				let container = $('#scroll')
				let target = $('#staff_list_wrapper')
				let target_inner = $('#staff_list')
				let scheduler_scroll_container = $('.calendar_default_scroll > div > div:last-of-type')
				let staff_list_header = $('#staff_list th')

				$('#staff_list th').addClass('scrolling_header')

				setTimeout(function () {
					// スクロール
					self.scrollToCurrentTime()
				}, 100)

				$(window).on('scroll', function () {
					let target_height = self.staff_list_scroll.target_first_height
					let window_y = $(window).scrollTop()
					let window_x = $(window).scrollLeft()
					let container_y = container.offset().top
					let scheduler_x = scheduler_scroll_container.scrollLeft()

					if (window_y > container_y + target_height) {
						if (container.css('margin-top') == '0px') {
							container.css('margin-top', target_height)
							target.addClass('staff_list_scroll')
						}
					}

					if (window_y < container_y - target_height) {
						if (container.css('margin-top') != '0px') {
							target.removeClass('staff_list_scroll')
							container.css('margin-top', 0)
							// target_inner.css('margin-left', 0)
						}
					}
				})

				scheduler_scroll_container.on('scroll', function () {
					let window_x = $(window).scrollLeft()
					let scheduler_x = scheduler_scroll_container.scrollLeft()

					if (self.is_staff_list_minimum) {
						if (window_x > 60 || scheduler_x > 60) {
							$('#staff_list th').addClass('scrolling_header')

							$('#row_skill_attribute th').css('height', $('#row_skill_attribute').innerHeight() + 'px')
						} else {
							$('#row_skill_attribute th').css('height', '')
						}
					} else {
						if (window_x > 120 || scheduler_x > 120) {
							$('#staff_list th').addClass('scrolling_header')
						} else {
							$('#row_skill_attribute th').css('height', '')
						}
					}

					if ($('#row_reservation th').hasClass('scrolling_header')) {
						if ($('#row_skill_attribute th').css('position') == 'sticky') {
							target_inner.css('margin-left', (-(window_x + scheduler_x)))
						} else {
							if (self.is_staff_list_minimum) {
								target_inner.css('margin-left', (-(window_x + scheduler_x)) + 0)
							} else {
								target_inner.css('margin-left', (-(window_x + scheduler_x)) + 60)
							}
						}
					} else {
						target_inner.css('margin-left', -(window_x + scheduler_x))
					}

					if ($('#row_skill_attribute th').hasClass('scrolling_header')) {
						$('#row_skill_attribute th').css('height', $('#row_skill_attribute').innerHeight() + 'px')
						// $('#row_skill_attribute th').css('line-height', ($('#row_skill_attribute').outerHeight()) + 'px')
					} else {
						$('#row_skill_attribute th').css('height', '')
						$('#row_skill_attribute th').css('line-height')
					}
				})
			})

			// 自動更新
			/*
			setInterval(() => {
				if (is_refreshable) {
					self.cronShort()
				}
			}, 3000)

			// 自動更新
			setInterval(() => {
				if (is_refreshable) {
					self.cronLong()
				}
			}, 26000)
			*/

			setInterval(() => {
				if (is_refreshable) {
					self.cronAll()
				}
			}, 5000)

			// 出勤
			// $('#add_staff_form_date').val(moment(self.params.date).format('YYYY-MM-DD'))
			self.add_staff_date_picker = moment(self.params.date).format('YYYY-MM-DD')

			$('#create_todo_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_todo_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#create_todo_dialog')).hide()
				}
			})

			$('#change_lane_type_dialog_close').on('click', function () {
				UIkit.modal($('#change_lane_type_dialog')).hide()
			})

			$('#create_event_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_event_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#create_event_dialog')).hide()
				}
			})

			$(document).on('click', '#edit_event_dialog_close', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_event_dialog')).hide()
						editFormDialogStopCountUp()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_event_dialog')).hide()
				}
			})

			$('#add_staff_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#add_staff_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#add_staff_form_dialog')).hide()
				}
			})

			$('#edit_event_form_plan_start_time').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#edit_event_form_plan_end_time').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#create_event_form_plan_start_time').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#create_event_form_plan_end_time').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#add_staff_form_start').on('click', function () {
				self.need_confirm_alert = true
			})

			$('#add_staff_form_end').on('click', function () {
				self.need_confirm_alert = true
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<style lang="scss" scoped>
	/* input[type="date"]::-webkit-inner-spin-button {

	} */

	/* input[type="time"]::-webkit-inner-spin-button {

	} */

	#header_reservation_count {
		vertical-align: middle;
		line-height: 1;
	}

	#header {
		.button_normal {
			background: #e1d4e6 !important;
		}

		.button_list {
			background: #d3e5f7 !important;
		}

		.button_todo {
			background: #FFFFFF !important;
		}
	}

	#scheduler {
		// width: 10000px;
		overflow: hidden;
	}


	#scroll {
		width: 100%;

		#up_scroll_button {
			position: fixed;
			left: 4px;
			bottom: 40px;
			z-index: 1002;
			background: #b9e0d9;
		}

		#left_scroll_button {
			position: fixed;
			top: 260px;
			right: 4px;
			z-index: 1002;
			background: #b9e0d9;
		}

		#staff_list_toggle {
			position: fixed;
			top: 180px;
			left: 4px;
			z-index: 1002;
			background: #b9e0d9;
		}

		#staff_list_add_staff {
			position: fixed;
			top: 180px;
			right: 4px;
			z-index: 1002;
			background: #b9e0d9;
		}
	}

	#staff_list_wrapper {
		width: 20000px !important;
		margin: 0 !important;
		background: #FFF;
		overflow: hidden;
		z-index: 998 !important;
	}

	#staff_list_table.normal {
		position: relative;

		.scrolling_header {
			position: sticky;
			left: 0;
			display: table-cell;
			background: #FFF;
			vertical-align: middle;
			border-top: none !important;
		}
	}

	#staff_list_table.min {
		position: relative;

		.scrolling_header {
			position: sticky;
			left: 0;
			display: table-cell;
			background: #FFF;
			vertical-align: middle;
			border-top: none !important;
		}
	}

	#staff_list_table.normal {
		table-layout: fixed;
		box-sizing: border-box;
		border-collapse: collapse;
		border: 1px solid #DDD;
		border-bottom: none;

		tr {
			border: 1px solid #DDD !important;
			box-sizing: border-box;

			th, td {
				padding: 0;
				border: 1px solid #DDD;
				box-sizing: border-box !important;
				text-align: center !important;
				font-size: 12px;
			}

			td {
				width: 120px !important;
			}

			th {
				width: 120px !important;
			}
		}
	}

	#staff_list_table.min {
		table-layout: fixed;
		box-sizing: border-box;
		border-collapse: collapse;
		border: 1px solid #DDD;
		border-bottom: none;

		tr {
			border: 1px solid #DDD !important;
			box-sizing: border-box;

			th, td {
				width: 60px !important;
				padding: 0 !important;
				border: 1px solid #DDD;
				box-sizing: border-box !important;
				text-align: center !important;
				font-size: 8px !important;
			}
		}
	}

	#staff_list {
		z-index: 998;
		//width: 20000px;
		background: #FFF;
	}

	#change_reservation_delete_mode.on {
		background: #2FCDB4;
		color: #FFF;
	}

	#lock_mode {
		#overlay {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1300;
			width: 100%;
			height: 100%;
			background: #000;
		}

		.form {
			position: fixed;
			top: 50%;
			left: 50%;
			-webkit-transform: translate(-50%, -50%);
			-moz-transform: translate(-50%, -50%);
			-ms-transform: translate(-50%, -50%);
			-o-transform: translate(-50%, -50%);
			transform: translate(-50%, -50%);
			z-index: 1301;
			width: 600px;
			padding: 40px;
			background: #FFF;
		}
	}

	.uk-modal {
		z-index: 1200 !important;
	}

	.uk-modal-body .uk-margin {
		margin-top: 2px !important;
		margin-bottom: 2px !important;
	}

	#reservation_breakdown_dialog,
	#todo_list_dialog {
		td, th {
			padding: 6px 2px;
		}
	}

	#row_todo td:hover,
	#row_job_position td:hover,
	#row_reservation td:hover {
		background: #EEE;
		cursor: pointer;
	}

	#create_event_dialog,
	#edit_event_dialog {
		[class*='uk-align'] {
			margin-bottom: 10px !important;
		}

		.uk-modal-title {
			line-height: 1;
			margin-bottom: 10px !important;
		}

		.uk-modal-body {
			padding: 10px !important;
		}
	}

	#row_skill_attribute th {
		text-decoration: underline;
		background: #EEEE99 !important;
		color: #00C;
		vertical-align: middle !important;
	}

	/* #row_skill_attribute td {
	} */

	.staff_list_scroll {
		position: fixed;
		top: 0;
	}
</style>
<style lang="scss">
	:root {
		//min-width: 1200px !important;
		--uk-breakpoint-m: 1px !important;
		--uk-breakpoint-s: 1px !important;
	}

	html, body {
		//overscroll-behavior: none;
		-webkit-overflow-scrolling: touch;
	}

	#datepicker {
		width: 300px;
	}

	.icon_design {
		text-shadow: black 1px 1px 0, black -1px -1px 0, /*右下、左上*/
		black -1px 1px 0, black 1px -1px 0, /*右上、左下*/
		black 0px 1px 0, black 0-1px 0, /*右、左*/
		black -1px 0 0, black 1px 0 0; /*上、下*/
	}

	#dialog_space {
		.dialog {
			width: 240px;
			position: fixed;
			top: 20px;
			left: 20px;
			background: #f5f5f5;
			box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.4);
			z-index: 999;

			.header {
				padding: 4px 20px;
				background: #0e6dcd;
				overflow: hidden;
			}

			.message {
				padding: 40px 20px;
				font-size: 12px;
			}
		}

		.help_dialog .header {
			background: #ee395b !important;
		}

		.exitension_dialog .header {
			background: #FFFF00 !important;
		}
	}


	#dp {
		//overscroll-behavior: contain;

		table {
			table-layout: fixed;
			border-collapse: collapse;
		}

		/* td, th {

		} */


		/* .calendar_default_scroll div:first-of-type {

		} */

		.calendar_default_scroll div:first-of-type > div:first-of-type > div:first-of-type {
			border-right: none;
		}

		.calendar_default_now {
			z-index: 888;
		}

		/* .calendar_default_scroll {
			//position: relative;
		} */

		/* .calendar_default_scroll div:first-of-type > div:first-of-type > div:first-of-type table {

		} */

		.calendar_default_rowheader_inner {
			font-size: 12px !important;
			font-weight: bold !important;
			text-align: center !important;
			vertical-align: middle !important;
		}

		.calendar_default_rowheader_minutes {
			display: none !important;
		}

		.calendar_default_event_inner {
			vertical-align: top !important;
		}

		.calendar_default_event_inner span {
			padding: 4px 0;
			font-size: 12px !important;
			font-weight: bold !important;
			text-align: left !important;
			vertical-align: middle !important;
			display: block;
			-webkit-user-select: none;
			-webkit-touch-callout: none;
		}

		.calendar_default_rowheader_inner {
			border-right: none !important;
		}

		.time_header_scroll {
			position: fixed !important;
			z-index: 999 !important;
		}

		/* .calendar_default_shadow {

		} */

		/* .calendar_default_shadow_inner {

		} */

		div[style*="overflow: auto"] {
			overflow: auto hidden !important;
			/* overflow-x: auto !important;
			overflow-y: hidden !important; */
		}
	}

	.background_oblique_line .calendar_default_event_inner {
		background-image: -webkit-gradient(linear, 0 0, 100% 100%, color-stop(.25, #F9F9F9), color-stop(.25, transparent), color-stop(.5, transparent), color-stop(.5, #F9F9F9), color-stop(.75, #F9F9F9), color-stop(.75, transparent), to(transparent)) !important;
		-webkit-background-size: 14px 14px !important;
	}

	.vdp-datepicker {
		z-index: 1100;
	}

	.time-picker {
		width: 100% !important;

		input {
			width: 100% !important;
		}
	}

	.el-date-editor {
		width: 100% !important;
	}
	.el-input__inner {
		border-radius: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/page/ReservationListPage.vue